import React, { useState, useCallback, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation } from "react-i18next";
import * as schemas from "../../../assets/schemas/schemas";
import {
  FollowingForm,
  ApprovalPaymentForm,
  CancelCaseForm,
  FailedCaseForm,
  CancelServiceForm,
  CreateAVForm,
  FollowUpForm,
  FinishServiceForm,
  ProvidersPaymenForm,
  CreateTowForm,
  CreateSalesUserForm,
  CreateAllyForm,
  EditSalesUserForm,
  CreatePaymentForm,
  EditPaymentForm,
  EditCashbackForm,
  FailureAssignForm,
  BlockAllyForm,
  ActivateDriverForm,
  CreateFleetMaintenanceForm,
  CreateFleetIncidenceForm,
  ComplaintsForm,
  BatterySaleForm,
} from "../Forms/Form";
import authService from "../../../services/authService";
import { operationsRoles } from "../../../assets/helpers/roles";
import { Input, SelectProvider } from "../../common/Forms/Input/Input";
import { useForm } from "react-hook-form";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { AltButton, ActionButton } from "../Buttons/Buttons";
import { Dropzone, FileComponent, NewDropzone } from "../Dropzone/Dropzone";
import { ScheduleServicesForm, ScheduleTowForm } from "../../common/Forms/Form";
import { caseService } from "../../../services/caseService";
import { membershipService } from "../../../services/membershipService";
import { servicesService } from "../../../services/servicesService";
import { refundService } from "../../../services/refundService";
import {
  getLocksmithFinishMode,
  getLocksmithService,
  locksmithFinishMode,
} from "../../../assets/helpers/caseValidations";
import { notify } from "../../../assets/helpers/toast";
import { exists, capitalize } from "../../../assets/helpers/funciones";
import {
  towSMSEnum,
  enumStatus,
  userType,
  caseType,
  resolveCancelReasonType,
  AVFaultServiceResolvedStatus,
  externalTowReasonsOptions,
  afiliatedServices,
  particularServices,
  banksOptions,
  locksmithPayMethods,
} from "../../../assets/helpers/options";
import { smsText } from "../../../assets/helpers/smsText";
import { useJsApiLoader } from "@react-google-maps/api";
import { CancelServicesTable } from "../../common/Tables/Tables";
import { cancelServiceHeader } from "../../../assets/helpers/tables";
import { Map } from "./Map";
import { LocationMap } from "./LocationMap";
import { AllDevicesMap } from "./AllDevicesMap";
import moment from "moment";
import { LoadSpinner } from "../LoadSpinner/LoadSpinner";
import { useDropzone } from "react-dropzone";
import {
  selectServiceHeader,
  selectCashbackHeader,
} from "../../../assets/helpers/tables";
import Select from "react-select";
import "./Modals.scss";

const CopyButton = ({ text, label = "Copiar" }) => {
  const [tooltip, setTooltip] = useState({
    visible: false,
    x: 0,
    y: 0,
  });
  const timeoutRef = useRef(null);
  const lastPosRef = useRef({ x: 0, y: 0 });

  const handleClick = (event) => {
    lastPosRef.current = { x: event.clientX, y: event.clientY };
  };

  const handleCopy = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    setTooltip({
      visible: true,
      x: lastPosRef.current.x + 12,
      y: lastPosRef.current.y - 8,
    });

    timeoutRef.current = setTimeout(() => {
      setTooltip((prev) => ({ ...prev, visible: false }));
    }, 1000);
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <>
      <CopyToClipboard text={text} onCopy={handleCopy}>
        <button className="copy-sms-text-button" onClick={handleClick}>
          {label}
        </button>
      </CopyToClipboard>
      {tooltip.visible && (
        <div
          className="copy-tooltip"
          style={{ top: tooltip.y, left: tooltip.x }}
        >
          Copiado
        </div>
      )}
    </>
  );
};

export const ScheduleServicesModal = (props) => {
  const { show, register, errors, handleClose, t, action, control } = props;

  return (
    <Modal size="lg" centered show={show} onHide={() => handleClose(false)}>
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h5>Agendar Servicio</h5>
        <h6 style={{ textAlign: "center" }}>
          Seleccione la fecha y hora para la cual desea agendar su servicio
        </h6>
        <ScheduleServicesForm
          t={t}
          register={register}
          errors={errors}
          action={action}
          control={control}
        />
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const ScheduleTowModal = (props) => {
  const { show, register, errors, handleClose, t, action, control } = props;

  return (
    <Modal size="lg" centered show={show} onHide={() => handleClose(false)}>
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h5>Agendar Servicio de Grúa</h5>
        <h6 style={{ textAlign: "center" }}>
          Seleccione la fecha, hora y motivo para agendar el servicio de grúa
        </h6>
        <ScheduleTowForm
          t={t}
          register={register}
          errors={errors}
          action={action}
          control={control}
        />
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const FollowingModal = (props) => {
  const { showFollowingModal, handleClose, refresh } = props;

  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schemas.UpdateTrackingSchema(t)),
  });
  const [isLoading, setIsloading] = useState(false);
  // Function that handles the logout request
  const onSubmit = handleSubmit(async (data) => {
    data.stage = showFollowingModal?.selected?.status;
    if (!isLoading) {
      setIsloading(true);
      caseService
        .updateCaseTracking(data, showFollowingModal?.selected?._id)
        .then((response) => {
          if (response.status === 200) {
            handleClose(true);
            notify(`Seguimiento añadido con éxito`, "success");
            refresh();
          } else {
            notify(`${response.message}`, "error");
            setIsloading(false);
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  });

  return (
    <Modal
      size="lg"
      centered
      show={showFollowingModal?.isOpen}
      onHide={() => handleClose(false)}
    >
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h5>Registrar seguimiento</h5>
        <FollowingForm
          t={t}
          register={register}
          errors={errors}
          action={onSubmit}
        />
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const CancelCaseModal = (props) => {
  const { showCancelCase, handleClose, refresh } = props;

  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schemas.CancelCaseSchema(t)),
  });
  const [isLoading, setIsloading] = useState(false);
  // Function that handles the logout request
  const onSubmit = handleSubmit(async (data) => {
    if (!isLoading) {
      setIsloading(true);
      caseService
        .cancelCase(data, showCancelCase?.selected?._id)
        .then((response) => {
          if (response.status === 200) {
            notify(`Caso cancelado con éxito`, "success");
            setIsloading(false);
            handleClose(false);
            refresh();
            reset();
          } else {
            notify(`${response.message}`, "error");
            setIsloading(false);
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  });

  const close = () => {
    handleClose(false);
    reset();
  };

  const cancelCase = () => {
    handleClose(false);
    refresh();
    reset();
  };

  return (
    <Modal
      size="lg"
      centered
      show={showCancelCase?.show}
      onHide={() => close()}
    >
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h5>Cancelar Caso</h5>
        <CancelCaseForm
          t={t}
          register={register}
          errors={errors}
          action={onSubmit}
          cancel={() => cancelCase()}
          cancelOptions={showCancelCase?.cancelOptions}
        />
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const ActivateDriverModal = (props) => {
  const { modal, handleModal, refresh, action, register, errors, watch } =
    props;

  const close = () => {
    handleModal();
  };

  const cancel = () => {
    handleModal();
    refresh();
  };

  return (
    <Modal size="lg" centered show={modal?.show} onHide={() => close()}>
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h5>
          {modal?.selected?.isActive === "Activo" ? "Desactivar" : "Activar"}{" "}
          chofer
        </h5>
        <ActivateDriverForm
          register={register}
          errors={errors}
          watch={watch}
          options={
            modal?.selected?.isActive === "Activo"
              ? modal?.options
              : modal?.filteredOptions
          }
          cancelOptions={modal?.cancelOptions}
          disabled={modal?.selected?.isActive === "Activo"}
        />
        <div className="buttons-center-container">
          <h6>
            ¿ Esta seguro que desea{" "}
            {modal?.selected?.isActive === "Activo" ? "desactivar" : "activar"}{" "}
            el chofer ?
          </h6>
        </div>
        <div className="buttons-center-container">
          <AltButton action={() => cancel()} label={"No"} />
          <ActionButton action={action} label={"Si"} />
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const RollbackStageModal = (props) => {
  const { modal, handleClose, refresh } = props;

  const [isLoading, setIsloading] = useState(false);
  // Function that handles the logout request

  const rollbackCase = () => {
    if (!isLoading) {
      setIsloading(true);
      caseService
        .rollbackStage(modal?.selected?._id)
        .then((response) => {
          if (response.status === 200) {
            notify(`Caso devuelto con éxito`, "success");
            setIsloading(false);
            handleClose(false);
            refresh();
          } else {
            notify(`${response.message}`, "error");
            setIsloading(false);
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  };

  const close = () => {
    handleClose(false);
  };

  const cancelCase = () => {
    handleClose(false);
    refresh();
  };

  return (
    <Modal size="lg" centered show={modal?.show} onHide={() => close()}>
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h5>Devolver Caso</h5>
        <div style={{ marginTop: "24px" }} className="buttons-center-container">
          <h6>
            ¿ Esta seguro que desea regresar el caso al estatus anterior ?
          </h6>
        </div>
        <div className="buttons-center-container">
          <AltButton action={cancelCase} label={"No"} />
          <ActionButton action={rollbackCase} label={"Si"} />
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const FailedCaseModal = (props) => {
  const { showCancelCase, handleClose, refresh } = props;

  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schemas.FailedCaseSchema(t)),
  });
  const [isLoading, setIsloading] = useState(false);
  // Function that handles the logout request

  const onSubmit = handleSubmit(async (data) => {
    let services = showCancelCase?.selected?.services;
    let dataToPost = {
      failedReason: data?.failedReason,
      isInternal: services[services?.length - 1]?.provider?.isInternal,
    };
    if (!isLoading) {
      setIsloading(true);
      caseService
        .failCase(dataToPost, showCancelCase?.selected?._id)
        .then((response) => {
          if (response.status === 200) {
            notify(`Caso marcado como fallido`, "success");
            setIsloading(false);
            handleClose(false);
            refresh();
            reset();
          } else {
            notify(`${response.message}`, "error");
            setIsloading(false);
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  });

  const close = () => {
    handleClose(false);
    refresh();
    reset();
  };

  return (
    <Modal
      size="lg"
      centered
      show={showCancelCase?.show}
      onHide={() => close()}
    >
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h5>Marcar como fallido</h5>
        <FailedCaseForm
          t={t}
          register={register}
          errors={errors}
          action={onSubmit}
          cancel={() => close()}
          cancelOptions={showCancelCase?.cancelOptions}
        />
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const CancelSingleServiceModal = (props) => {
  const { modal, handleClose, refresh } = props;

  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schemas.CancelServiceSchema()),
  });
  const [isLoading, setIsloading] = useState(false);
  // Function that handles the logout request
  const onSubmit = handleSubmit(async (data) => {
    if (!isLoading) {
      setIsloading(true);
      servicesService
        .cancelService(data, modal?.service)
        .then((response) => {
          if (response.status === 200) {
            notify(`Servicio cancelado con éxito`, "success");
            setIsloading(false);
            handleClose(false);
            refresh();
            reset();
          } else {
            notify(`${response.message}`, "error");
            setIsloading(false);
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  });

  const close = () => {
    handleClose(false);
    refresh();
    reset();
  };

  return (
    <Modal size="lg" centered show={modal?.show} onHide={() => close()}>
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h5>Cancelar Servicio</h5>
        <CancelServiceForm
          t={t}
          register={register}
          errors={errors}
          action={onSubmit}
          cancel={() => close()}
          cancelOptions={modal?.cancelOptions}
        />
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const ChangeOperatorModal = (props) => {
  const { showChangeOperatorModal, handleClose, refresh, options } = props;
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
  } = useForm({
    resolver: yupResolver(schemas.ChangeOperatorSchema(t)),
  });
  const [isLoading, setIsloading] = useState(false);
  // Function that handles the logout request
  const onSubmit = handleSubmit(async (data) => {
    if (!isLoading) {
      setIsloading(true);
      caseService
        .changeOperator(data, showChangeOperatorModal?.selected?._id)
        .then((response) => {
          if (response.status === 200) {
            notify(`Operador modificado con exito`, "success");
            setIsloading(false);
            handleClose(false);
            refresh();
            reset();
          } else {
            notify(`${response.message}`, "error");
            setIsloading(false);
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  });

  let close = () => {
    reset();
    handleClose();
  };

  let filteredOperators = options?.filter(
    (o) => o?._id !== showChangeOperatorModal?.selected?.user?._id
  );

  return (
    <Modal
      size="lg"
      centered
      show={showChangeOperatorModal?.isOpen}
      onHide={() => handleClose(false)}
    >
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h5>
          Cambiar Operador para el caso{" "}
          {showChangeOperatorModal?.selected?.caseId}
        </h5>

        <form className="form-container">
          <div className="row">
            <Input
              bootstrap={"col-12"}
              label={"Listado de Operadores*"}
              type={"select"}
              options={filteredOperators}
              name={"user"}
              register={register}
              placeholder={""}
              errors={errors?.user?.message}
            />
          </div>
          <div className="buttons-center-container">
            {watch("user") && (
              <p style={{ textAlign: "center" }}>
                ¿Está seguro que desea cambiar el operador de <br />
                <b>
                  {showChangeOperatorModal?.selected?.user?.firstName +
                    "  " +
                    showChangeOperatorModal?.selected?.user?.lastName}
                </b>
                {"   "}a{"  "}
                <b>
                  {options.filter((o) => o?._id === watch("user"))[0]?.name}
                </b>{" "}
                ?
              </p>
            )}{" "}
          </div>
          <div className="buttons-center-container">
            <AltButton action={() => close()} label={"No"} />
            {watch("user") ? (
              <ActionButton action={onSubmit} label={"Si, cambiar operador"} />
            ) : (
              <span></span>
            )}
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const FollowUpSection = (props) => {
  const {
    i,
    control,
    register,
    watch,
    errors,
    options,
    filteredOperators,
    close,
    action,
  } = props;

  return (
    <>
      <div style={{ marginTop: "12px" }}>
        <h6>
          Seguimiento {i + 1} Fecha planificada{" "}
          <b className="service-code">{watch(`plannedDate${i}`)}</b>{" "}
        </h6>
      </div>
      <Input
        bootstrap={"col-3"}
        label={"Fecha de Contacto *"}
        type={"date"}
        control={control}
        name={`when${i}`}
        register={register}
        placeholder={""}
        errors={errors?.[`when${i}`]?.message}
        disabled={true}
      />{" "}
      <Input
        bootstrap={"col-3"}
        label={"Hora de Contacto *"}
        type={"time"}
        control={control}
        name={`time${i}`}
        register={register}
        placeholder={""}
        errors={errors?.[`when${i}`]?.message}
        disabled={true}
      />{" "}
      <Input
        bootstrap={"col-3"}
        label={"Canal de Contacto *"}
        type={"select"}
        options={options?.contactChannelOptions}
        name={`channel${i}`}
        register={register}
        placeholder={""}
        errors={errors?.[`channel${i}`]?.message}
        disabled={watch(`edited${i}`) || (i > 0 && !watch(`edited${i - 1}`))}
      />{" "}
      <Input
        bootstrap={"col-3"}
        label={"Operador*"}
        type={"select"}
        options={filteredOperators}
        name={`user${i}`}
        register={register}
        placeholder={""}
        errors={errors?.[`user${i}`]?.message}
        disabled={watch(`edited${i}`) || (i > 0 && !watch(`edited${i - 1}`))}
      />{" "}
      <Input
        bootstrap={"col-6"}
        label={"Observación"}
        type={"textarea"}
        name={`note${i}`}
        register={register}
        placeholder={""}
        errors={errors?.[`note${i}`]?.message}
        disabled={watch(`edited${i}`) || (i > 0 && !watch(`edited${i - 1}`))}
      />{" "}
      {(i === 0 || (i > 0 && watch(`edited${i - 1}`))) &&
        !watch(`edited${i}`) && (
          <div className="col-6">
            <div
              style={{ marginTop: "60px" }}
              className="buttons-center-container"
            >
              <AltButton action={() => close()} label={"Cancelar"} />
              <ActionButton action={() => action(i)} label={"Guardar"} />
            </div>
          </div>
        )}
    </>
  );
};

export const RegisterFollowUPModal = (props) => {
  const {
    modal,
    handleClose,
    control,
    register,
    watch,
    errors,
    options,
    action,
  } = props;

  // Function that handles the logout request
  // let filteredOperators = options?.operatorsOptions?.filter(
  //   (o) => o?._id === modal?.selected?.user?._id
  // );

  return (
    <Modal
      size="xl"
      centered
      show={modal?.isOpen}
      onHide={() => handleClose(false)}
    >
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h5>Registrar Seguimiento en viaje</h5>

        <p>
          Código de Servicio:{" "}
          <b className="service-code">
            {modal?.selected?.services?.length > 0
              ? modal?.selected?.services[0]?.code
              : ""}
          </b>
        </p>

        <div style={{ maxWidth: "900px" }} className="form-container">
          <div className="row">
            {modal?.selected?.services?.length > 0
              ? modal?.selected?.services[0]?.tripTracking?.trackings?.map(
                (a, i) => (
                  <FollowUpSection
                    register={register}
                    control={control}
                    watch={watch}
                    errors={errors}
                    options={options}
                    filteredOperators={options?.operatorsOptions}
                    close={handleClose}
                    action={action}
                    i={i}
                  />
                )
              )
              : null}
          </div>
          <div className="buttons-center-container">
            {watch("user") && (
              <p style={{ textAlign: "center" }}>
                ¿Está seguro que desea cambiar el operador de <br />
                <b>
                  {modal?.selected?.user?.firstName +
                    "  " +
                    modal?.selected?.user?.lastName}
                </b>
                {"   "}a{"  "}
                <b>
                  {options.filter((o) => o?._id === watch("user"))[0]?.name}
                </b>{" "}
                ?
              </p>
            )}{" "}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const FinishCaseModal = (props) => {
  const { handleClose, options, refresh, finishCaseModal } = props;

  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schemas.FinishServiceSchema()),
  });
  const [isLoading, setIsloading] = useState(false);
  // Function that handles the logout request
  const onSubmit = handleSubmit(async (data) => {
    let dataToPost = { ...data };

    dataToPost.solvedByAV = false;
    dataToPost.stage = finishCaseModal?.selected?.lastStage?._id;
    if (!isLoading) {
      setIsloading(true);
      caseService
        .finishCase(dataToPost, finishCaseModal?.selected?._id)
        .then((response) => {
          if (response.status === 200) {
            notify(`Caso Finalizado con éxito`, "success");
            setIsloading(false);
            handleClose(false);
            reset();
            refresh();
          } else {
            notify(`${response.message}`, "error");
            setIsloading(false);
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  });

  return (
    <Modal
      size="lg"
      centered
      show={finishCaseModal?.isOpen}
      onHide={finishCaseModal?.thirdParty ? "" : () => handleClose(false)}
    >
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h5>Finalizar Caso</h5>
        <FinishServiceForm
          t={t}
          register={register}
          errors={errors}
          action={onSubmit}
          cancel={() => handleClose(false)}
          options={options}
          actionLabel="Finalizar Caso"
          modal={finishCaseModal}
          setValue={setValue}
        />
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const ProdiversPaymentModal = (props) => {
  const {
    handleModal,
    options,
    register,
    errors,
    action,
    modal,
    watch,
    onChange,
    control,
    type,
    fileUploaded,
    removeFile,
    onDrop,
    showErrorAPI,
  } = props;
  return (
    <Modal size="xl" centered show={modal?.isOpen} onHide={() => handleModal()}>
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h5>CONFIRMACIÓN DEL PAGO</h5>
        <ProvidersPaymenForm
          control={control}
          type={type}
          modal={modal}
          register={register}
          watch={watch}
          onChange={onChange}
          errors={errors}
          action={action}
          cancel={() => handleModal()}
          options={options}
          fileUploaded={fileUploaded}
          onDrop={onDrop}
          removeFile={removeFile}
          showErrorAPI={showErrorAPI}
        />
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const ConciliateModal = (props) => {
  const {
    handleModal,
    action,
    modal,
    conciliateTableHeader,
    register,
    errors,
    control,
  } = props;

  return (
    <Modal size="xl" centered show={modal?.isOpen} onHide={() => handleModal()}>
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h5>CONCILIACIÓN DE PAGO</h5>
        <table className="table">
          <tr>
            {conciliateTableHeader.map((h) => (
              <th key={h?.value}>{h?.name}</th>
            ))}
          </tr>
          {modal?.conciliate.length > 0 &&
            modal?.conciliate.map((d) => (
              <tr key={d?._id}>
                <td>{exists(d?.providerName || d?.providerCompany)}</td>
                <td>{moment(d?.createdAt).format("DD/MM/YYYY")}</td>
                <td>{capitalize(d?.product)}</td>
                <td>{exists(d?.caseType)}</td>
                <td>{exists(d?.code)}</td>
                <td>{exists(d?.providerPay?.toFixed(2))}$</td>
              </tr>
            ))}
        </table>
        <br />

        <h6 style={{ margin: "0px" }}>
          ¿Los pagos de esta conciliacion se ejecutaran el miercoles?
        </h6>
        <div className="row">
          <Input
            bootstrap={"col-12"}
            label={""}
            type={"date"}
            name={"paymentDate"}
            control={control}
            register={register}
            minDate={new Date()}
            placeholder={""}
            errors={errors?.paymentDate?.message}
          />{" "}
        </div>
        <div className="buttons-center-container">
          <AltButton action={() => handleModal()} label={"Cancelar"} />
          <ActionButton action={action} label={"Conciliar"} />
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const ConciliationSummaryModal = (props) => {
  const { handleModal, action, modal, register, errors, control } = props;

  return (
    <Modal size="xl" centered show={modal} onHide={() => handleModal()}>
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h5>RESUMEN DE CONCILIACIÓN</h5>
        <h6 style={{ margin: "0px" }}>Fecha de conciliacion</h6>
        <div className="row">
          <Input
            bootstrap={"col-12"}
            label={""}
            type={"date"}
            name={"reconciledDate"}
            control={control}
            register={register}
            placeholder={""}
            errors={errors?.reconciledDate?.message}
          />{" "}
        </div>
        <div className="buttons-center-container">
          <AltButton action={() => handleModal()} label={"Cancelar"} />
          <ActionButton action={action} label={"Solicitar Resumen"} />
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const SolvedByAVModal = (props) => {
  const { handleClose, options, refresh, solvedByAVModal } = props;

  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    resolver: yupResolver(schemas.FinishServiceSchema()),
  });
  const [isLoading, setIsloading] = useState(false);
  // Function that handles the logout request
  const onSubmit = handleSubmit(async (data) => {
    let dataToPost = { ...data };

    dataToPost.solvedByAV = true;
    dataToPost.stage = solvedByAVModal?.selected?.lastStage?._id;

    let incidence = solvedByAVModal?.selected;
    // Update validation with role
    if (incidence) {
      let [services] = incidence?.services?.filter(
        (s) => s?.type === "Asistencia vial" && s?.status !== "Cancelado"
      );
      if (
        services && (!services?.avImage) && ![operationsRoles?.operationsAdmin, operationsRoles?.operationsSupervisor,].includes(authService?.getUserType())
      ) {
        notify("Falta subir imagenes de la asistencia", "error");
        return null;
      }
    }
    if (!isLoading) {
      setIsloading(true);
      caseService
        .finishCase(dataToPost, solvedByAVModal?.selected?._id)
        .then((response) => {
          if (response.status === 200) {
            notify(`Caso Finalizado con éxito`, "success");
            setIsloading(false);
            handleClose(false);
            reset();
            refresh();
          } else {
            notify(`${response.message}`, "error");
            setIsloading(false);
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  });

  return (
    <Modal
      size="lg"
      centered
      show={solvedByAVModal?.isOpen}
      onHide={() => handleClose(false)}
    >
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h5>Falla Resuelta por Motorizado</h5>
        <FinishServiceForm
          t={t}
          register={register}
          errors={errors}
          action={onSubmit}
          cancel={() => handleClose(false)}
          options={options}
          modal={solvedByAVModal}
          setValue={setValue}
          actionLabel="Falla resuelta por motorizado"
        />
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const FinishTowCaseModal = (props) => {
  const { handleClose, options, refresh, solvedByAVModal } = props;

  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    resolver: yupResolver(
      schemas.FinishServiceSchema(solvedByAVModal?.selected?.status)
    ),
  });

  const [isLoading, setIsloading] = useState(false);
  // Function that handles the logout request
  const onSubmit = handleSubmit(async (data) => {
    let dataToPost = { ...data };

    dataToPost.solvedByAV = false;
    dataToPost.stage = solvedByAVModal?.selected?.lastStage?._id;

    // Finish follow up cases
    if (
      !dataToPost?.providerFailureReason &&
      !dataToPost?.providerFailureDescription
    ) {
      delete dataToPost?.providerFailureReason;
      delete dataToPost?.providerFailureDescription;
    }

    if (!isLoading) {
      setIsloading(true);
      caseService
        .finishCase(dataToPost, solvedByAVModal?.selected?._id)
        .then((response) => {
          if (response.status === 200) {
            notify(`Caso Finalizado con éxito`, "success");
            setIsloading(false);
            handleClose(false);
            reset();
            refresh();
          } else {
            notify(`${response.message}`, "error");
            setIsloading(false);
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  });

  return (
    <Modal
      size="lg"
      centered
      show={solvedByAVModal?.isOpen}
      onHide={() => handleClose(false)}
    >
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h5>Finalizar casos</h5>
        <FinishServiceForm
          t={t}
          modal={solvedByAVModal}
          register={register}
          errors={errors}
          action={onSubmit}
          cancel={() => handleClose(false)}
          options={options}
          setValue={setValue}
          actionLabel="Finalizar Caso"
        />
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const FailureAssignTowModal = (props) => {
  const { handleClose, options, solvedByAVModal, createTowService } = props;

  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schemas.FinishServiceSchema()),
  });
  const [isLoading, setIsloading] = useState(false);
  // Function that handles the logout request
  const onSubmit = handleSubmit(async (data) => {
    let dataToPost = { ...data };

    if (!isLoading) {
      setIsloading(true);
      caseService
        .updateProviderFailureReason(dataToPost, solvedByAVModal?.selected?._id)
        .then((response) => {
          if (response.status === 200) {
            notify(`Caso actualizado`, "success");
            setIsloading(false);
            handleClose(false);
            createTowService(solvedByAVModal?.selected);
          } else {
            notify(`${response.message}`, "error");
            setIsloading(false);
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  });

  return (
    <Modal
      size="lg"
      centered
      show={solvedByAVModal?.isOpen}
      onHide={() => handleClose(false)}
    >
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h5>Actualizar caso</h5>
        <FailureAssignForm
          t={t}
          register={register}
          errors={errors}
          action={onSubmit}
          cancel={() => handleClose(false)}
          options={options}
          actionLabel="Actualizar"
          setValue={setValue}
        />
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const LogOutModal = (props) => {
  const { handleModal, modal, action } = props;

  return (
    <Modal
      size="lg"
      centered
      show={modal?.isOpen}
      onHide={() => handleModal(false)}
    >
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h5> ¿Está seguro que desea cerrar sesión ?</h5>
      </Modal.Body>
      <br />
      <br />
      <div className="buttons-center-container">
        <AltButton label={"No"} action={() => handleModal()} />
        <ActionButton action={() => action()} label={"Si"} />
      </div>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const ChangeProviderModal = (props) => {
  const { handleClose, options, changeProviderModal, value, onChange, action } =
    props;

  let filteredBikers = options?.filter(
    (o) => o?._id !== changeProviderModal?.selected?.lastService?.provider?._id
  );

  return (
    <Modal
      size="lg"
      centered
      show={changeProviderModal?.isOpen}
      onHide={() => handleClose(false)}
    >
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h5>
          Cambiar motorizado para el caso{" "}
          {changeProviderModal?.selected?.caseId}
        </h5>

        <div className="col-12 col-md-8" style={{ marginTop: "30px" }}>
          <Select
            options={filteredBikers}
            placeholder="Seleccione una opción"
            isSearchable
            // value={value}
            onChange={(e) => onChange(e)}
          />
        </div>

        {value && (
          <p style={{ textAlign: "center" }}>
            ¿Está seguro que desea cambiar el motorizado de <br />
            <b>
              {
                changeProviderModal?.selected?.lastService?.provider
                  ?.contactName
              }
            </b>
            {"   "}a{"  "}
            <b>{options.filter((o) => o?._id === value)[0]?.contactName}</b> ?
          </p>
        )}

        <br />
        <div className="buttons-center-container">
          <AltButton label={"No"} action={() => handleClose(false)} />{" "}
          {value && (
            <ActionButton
              action={() => action()}
              label={"Cambiar motorizado"}
            />
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const ChangeTowModal = (props) => {
  const {
    // towType,
    handleClose,
    options,
    changeProviderModal,
    value,
    onChange,
    action,
    register,
    errors,
    watch,
  } = props;

  let filteredTows = [];

  const isScheduledService =
    changeProviderModal?.selected?.status === enumStatus?.SCHEDULED;

  const isSelectableTow = (o) =>
    o?._id !== changeProviderModal?.selected?.lastService?.provider?._id &&
    (isScheduledService || !o?._id || o?.isActive !== false);

  if (watch("towType") === userType?.INTERNO) {
    filteredTows = options?.towOptions?.filter(isSelectableTow);
  }

  if (watch("towType") === userType?.EXTERNO) {
    filteredTows = options?.externalTowOptions?.filter(isSelectableTow);
  }

  const showOTP = () => {
    if (
      changeProviderModal?.selected?.originState &&
      ["DISTRITO CAPITAL", "MIRANDA", "LA GUAIRA"].includes(
        changeProviderModal?.selected?.originState?.name
      ) &&
      changeProviderModal?.selected?.lastService?.provider?.isInternal ===
      false &&
      changeProviderModal?.selected?.lastService?.product?.code === "GRUA"
    ) {
      const now = moment();
      const startTime = moment().set({
        hour: 7,
        minute: 30,
        second: 0,
        millisecond: 0,
      });
      const endTime = moment().set({
        hour: 21,
        minute: 59,
        second: 59,
        millisecond: 999,
      });

      return now.isBetween(startTime, endTime);
    } else {
      return false;
    }
  };

  const validateCanPost = () => {
    if (watch("towType") === userType?.INTERNO && value) {
      return true;
    }

    if (
      watch("towType") === userType?.EXTERNO &&
      value &&
      watch("externalTowReason")
    ) {
      if (showOTP()) {
        if (watch("validCode") && watch("approvedBy")) {
          return true;
        } else if (
          changeProviderModal?.selected?.lastService?.provider?.isInternal ===
          true &&
          changeProviderModal?.selected?.lastService?.product?.code === "GRUA"
        ) {
          return true;
        } else return false;
      }
      return true;
    } else return false;
  };
  return (
    <Modal
      size="lg"
      centered
      show={changeProviderModal?.isOpen}
      onHide={() => handleClose(false)}
    >
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h5>
          Cambiar Gruero para el caso {changeProviderModal?.selected?.caseId}
        </h5>
        <div className="row" style={{ minWidth: "700px" }}>
          <Input
            bootstrap={"col-6"}
            label={"Tipo de Gruero:"}
            type={"select"}
            options={options?.userTypeOptions}
            name={"towType"}
            register={register}
            placeholder={""}
            onChange={() => onChange?.handleTowType()}
            errors={errors?.towType?.message}
          />

          <div className="col-12 col-md-6" style={{ marginTop: "6px" }}>
            <label>Elegir Gruero:</label>
            <Select
              options={filteredTows}
              placeholder="Seleccione una opción"
              isSearchable
              // value={value}
              onChange={(e) => onChange?.handleTow(e)}
            />
          </div>
          {watch("towType") === userType?.EXTERNO && (
            <>
              <Input
                bootstrap={"col-6"}
                label={"Motivo de Selección de Grúa externa"}
                type={"select"}
                options={externalTowReasonsOptions}
                name={"externalTowReason"}
                register={register}
                placeholder={""}
                errors={errors?.externalTowReason?.message}
              />
              {showOTP() && (
                <>
                  <Input
                    bootstrap={"col-6"}
                    label={"Aprobado por "}
                    type={"select"}
                    options={options?.authorizedByOptions}
                    name={"approvedBy"}
                    register={register}
                    placeholder={""}
                    errors={errors?.approvedBy?.message}
                    disabled={watch("validCode") && watch("approvedBy")}
                  />
                  <Input
                    bootstrap={"col-6"}
                    label={"OTP"}
                    type={"text"}
                    name={"code"}
                    register={register}
                    placeholder={""}
                    errors={errors?.code?.message}
                    disabled={watch("validCode")}
                  />
                  {value && !watch("validCode") && (
                    <div className="col-6">
                      <div
                        style={{ marginTop: "32px" }}
                        className="buttons-center-container"
                      >
                        {watch("code") ? (
                          <ActionButton
                            action={() => onChange?.validateTowOTP()}
                            label={"Validar OTP"}
                          />
                        ) : (
                          <ActionButton
                            action={() => onChange?.requestTowOTP()}
                            label={"Solicitar OTP"}
                          />
                        )}
                      </div>
                    </div>
                  )}
                </>
              )}
            </>
          )}
        </div>

        {watch("towType") && value && (
          <p style={{ textAlign: "center" }}>
            ¿Está seguro que desea cambiar el gruero de <br />
            <b>
              {
                changeProviderModal?.selected?.lastService?.provider
                  ?.contactName
              }
            </b>
            {"   "}a{"  "}
            <b>
              {capitalize(
                filteredTows?.filter((o) => o?._id === value)[0]?.contactName
              )}
            </b>{" "}
            ?
          </p>
        )}

        <br />
        <div className="buttons-center-container">
          <AltButton label={"No"} action={() => handleClose(false)} />{" "}
          {validateCanPost() && (
            <ActionButton action={action} label={"Cambiar gruero"} />
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const TaxiServiceModal = (props) => {
  const {
    modal,
    handleClose,
    register,
    errors,
    watch,
    requestTaxiOtp,
    validateTaxiCode,
    otpCooldown = 0,
  } = props;

  const handleRequestOtp = () => {
    if (modal?.selected?.lastService?._id && requestTaxiOtp) {
      requestTaxiOtp(modal.selected.lastService._id);
    }
  };

  const hasCode = !!(watch?.("code") ?? "").trim();

  return (
    <Modal
      size="lg"
      centered
      show={modal?.isOpen}
      onHide={() => handleClose()}
    >
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h5 style={{ marginBottom: "24px" }}>Servicio de Taxi</h5>
        <div className="row" style={{ minWidth: "300px" }}>
          <Input
            bootstrap="col-12"
            label="Codigo OTP"
            type="text"
            name="code"
            register={register}
            placeholder=""
            errors={errors?.code?.message}
          />
        </div>
        <br />
        <div className="buttons-center-container">
          <AltButton label="Cerrar" action={() => handleClose()} />
          {hasCode ? (
            <ActionButton
              label="Validar Codigo"
              action={() => validateTaxiCode?.()}
            />
          ) : (
            <ActionButton
              label={otpCooldown > 0 ? `Solicitar OTP (${otpCooldown}s)` : "Solicitar OTP"}
              action={handleRequestOtp}
              disabled={otpCooldown > 0}
            />
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const MessageAVModal = (props) => {
  const { showSMSModal, handleClose, caseInfo, action, service, _case } = props;

  return (
    <Modal
      size="xl"
      centered
      show={showSMSModal?.isOpen}
      onHide={() => handleClose(false)}
    >
      <Modal.Header className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h4>Mensajes de selección de AV</h4>
        <div className="modal-messages-container">
          <MessageComponent1
            data={caseInfo}
            provider={showSMSModal?.provider}
            service={service}
            _case={_case}
          />
          <MessageComponent2
            data={caseInfo}
            provider={showSMSModal?.provider}
          />
          {![
            afiliatedServices.BATT_SALE,
            particularServices.BATT_SALE_PART,
          ].includes(service?.code) && (
              <>
                <MessageComponent3
                  data={caseInfo}
                  provider={showSMSModal?.provider}
                  service={service}
                />
              </>
            )}
        </div>
        <div className="modal-messages-container">
          <div>
            <MessageComponent4
              data={caseInfo}
              provider={showSMSModal?.provider}
            />
          </div>
          <div className="sms-modal-text-container ">
            <MessageComponent8
              data={caseInfo}
              provider={showSMSModal?.provider}
            />
            <div className="amount-baremo-container">
              <p>
                Monto de grua externa segun Baremo:{" "}
                {caseInfo?.priceDetails?.externalFinalPrice}$
              </p>
            </div>
          </div>
        </div>

        <div className="buttons-center-container">
          <AltButton label={"Cerrar"} action={() => handleClose(false)} />{" "}
          {action && <AltButton label={"Continuar"} action={() => action()} />}
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const MessageLocksmithModal = (props) => {
  const { showSMSModal, handleClose, caseInfo, action, service, _case } = props;
  const locksmithService = service?.code
    ? service
    : { code: afiliatedServices.LOCKSMITH };

  return (
    <Modal
      size="xl"
      centered
      show={showSMSModal?.isOpen}
      onHide={() => handleClose(false)}
    >
      <Modal.Header className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h4>Mensajes de selección de proveedor</h4>
        <div className="modal-messages-container">
          <MessageComponent1
            data={caseInfo}
            provider={showSMSModal?.provider}
            service={locksmithService}
            _case={_case}
          />
          <MessageComponentLocksmith
            data={caseInfo}
            provider={showSMSModal?.provider}
          />
        </div>
        <div className="buttons-center-container">
          <AltButton label={"Cerrar"} action={() => handleClose(false)} />{" "}
          {action && <AltButton label={"Continuar"} action={() => action()} />}
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const MessageComponentLocksmith = (props) => {
  const { data, provider } = props;

  const isDCOrMiranda = ["DISTRITO CAPITAL", "MIRANDA"].includes(
    `${data?.originState?.name}`.toUpperCase()
  );
  const phone = [provider?.phonePrefix, provider?.phoneNumber]
    .filter(Boolean)
    .join("-");

  return (
    <div>
      <h5 style={{ textAlign: "center" }}>Mensaje a cliente</h5>
      <div className="modal-message-container">
        <p>
          {isDCOrMiranda ? (
            <>
              Hola, ya estamos en contacto con el proveedor que atenderá tu
              servicio de cerrajería 🔑
              <br />
              <br />
              En breve te iremos informando el estatus de tu caso y te
              notificaremos cuando el proveedor vaya en camino.
              <br />
              <br />
              Gracias por confiar en Tu Gruero ✅
            </>
          ) : (
            <>
              Hola, te recomendamos el siguiente proveedor para tu servicio de
              cerrajería 🔑
              {provider?.contactName && (
                <>
                  <br />
                  <br />
                  Datos del proveedor:
                  <br />
                  <br />
                  <b>*Nombre: {capitalize(provider?.contactName)} *</b>
                  {phone && (
                    <>
                      <br />
                      <b>*Teléfono: {phone} *</b>
                    </>
                  )}
                  <br />
                  <br />
                  Comunícate directamente con el proveedor para coordinar la
                  atención.
                </>
              )}
              <br />
              <br />
              <b>
                *Tu Gruero asume el costo del servicio hasta un máximo de 30
                USD.*
              </b>{" "}
              Si el costo es mayor, la diferencia corre por tu cuenta.
              <br />
              <br />
              Paga el servicio al proveedor y envíanos la factura por este
              chat.{" "}
              <b>*La factura es obligatoria para procesar tu reembolso.*</b>
              <br />
              <br />
              El reembolso se realiza en un máximo de <b>*7 días hábiles*</b>{" "}
              después de recibir la factura ✅
            </>
          )}
        </p>
        <CopyButton text={smsText.locksmithMessageToClient(data, provider)} />
      </div>
    </div>
  );
};

export const MessageComponent1 = (props) => {
  const { data, provider, service, _case } = props;
  const isLocksmith = [
    service?.code,
    service?.product?.code,
    data?.lastService?.product?.code,
  ].includes(afiliatedServices.LOCKSMITH);
  const providerLabel = isLocksmith ? "PROVEEDOR RECOMENDADO" : "OPERADOR RECOMENDADO";
  const providerValue =
    isLocksmith && !provider?.contactName
      ? "Sin proveedor recomendado"
      : `@${capitalize(provider?.contactName)}`;
  const requestedService = isLocksmith
    ? "Cerrajería"
    : capitalize(service?.product || data?.lastService?.product?.name);
  return (
    <div>
      <h5 style={{ textAlign: "center" }}>Grupo Verde</h5>
      <div className="modal-message-container">
        <p>
          <b>*POR FAVOR RECUERDA QUE NO SE DEBE PEDIR LA UBICACIÓN AL CLIENTE*</b>
          <br />
          <br />
          <b>
            *SERVICIO DE TU/GRUERO{" "}
            {data?.thirdPartyParticularCustomerName && "(NO SOLVENTAR AVERIA)"}*{" "}
            {data?.particularCustomer?._id && " Particular"}
          </b>
          <br />-<b>*FECHA DE CREACIÓN*</b>:{" "}
          {moment(data?.createdAt).format("DD/MM/YYYY")}{" "}
          {moment(data?.createdAt).format("LT")}
          {data?.scheduleDate ? (
            <>
              <br />-<b>*FECHA DE SERVICIO*</b>:{" "}
              {moment(data?.scheduleDate).format("DD/MM/YYYY")}{" "}
              {moment(data?.scheduleDate).format("LT")}
            </>
          ) : (
            <>
              <br />-<b>*FECHA DE SERVICIO*</b>:{" "}
              {moment(data?.createdAt).format("DD/MM/YYYY")}{" "}
              {moment(data?.createdAt).format("LT")}
            </>
          )}{" "}
          <br />-<b>*CLIENTE*</b>:{" "}
          {capitalize(
            data?.thirdPartyParticularCustomerName ||
            data?.particularCustomer?.firstName ||
            data?.membership?.customer?.firstName ||
            data?.vehicleData?.firstName
          ) +
            " " +
            capitalize(
              data?.thirdPartyParticularCustomerLastName ||
              data?.particularCustomer?.lastName ||
              data?.membership?.customer?.lastName ||
              data?.vehicleData?.lastName
            )}
          <br />-<b>*TELÉFONO*</b>:
          {[
            caseType.AFFILIATED,
            caseType.PARTICULAR,
            caseType.PRIMARY_CARE,
          ].includes(data?.caseType) && (
              <>
                {" " +
                  exists(
                    data?.thirdPartyServicePhonePrefix ||
                    data?.contactNumberPrefix
                  ) +
                  exists(
                    data?.thirdPartyServicePhoneNumber || data?.contactNumber
                  )}
              </>
            )}
          {[caseType.ALLY].includes(data?.caseType) && (
            <>
              {exists(data?.vehicleData.phonePrefix) +
                exists(data?.vehicleData.phoneNumber)}
            </>
          )}
          <br />-<b>*PLACA*</b>:{" "}
          {exists(
            data?.thirdPartyVehiclePlate ||
            data?.particularCustomer?.vehiclePlate ||
            data?.membership?.vehicle?.plate ||
            data?.vehicleData?.plate
          )}
          <br />-<b>*VEHICULO*</b>:{" "}
          {capitalize(
            data?.thirdPartyVehicleBrand?.brand ||
            data?.particularCustomer?.vehicleBrand?.brand ||
            data?.membership?.vehicle?.brand ||
            data?.vehicleData?.brand?.brand
          ) +
            " " +
            capitalize(
              data?.thirdPartyVehicleModel?.model ||
              data?.particularCustomer?.vehicleModel?.model ||
              data?.membership?.vehicle?.model ||
              data?.vehicleData?.model?.model
            ) +
            " " +
            capitalize(
              data?.thirdPartyVehicleYear ||
              data?.particularCustomer?.vehicleYear ||
              data?.membership?.vehicle?.year ||
              data?.vehicleData?.year
            ) +
            " " +
            capitalize(
              data?.thirdPartyVehicleColor ||
              data?.particularCustomer?.vehicleColor ||
              data?.membership?.vehicle?.color ||
              data?.vehicleData?.color
            )}
          <br />-<b>*AVERÍA*</b>: {capitalize(data?.fault?.description)}
          <br />-<b>*COMENTARIO AVERÍA*</b>:{" "}
          {capitalize(
            data?.customerFailureDescription
              ? data?.customerFailureDescription
              : "Ninguno"
          )}
          <br />-<b>*ORIGEN*</b>:{capitalize(data?.originAddress)}
          <br />
          {data?.originReferencePoint ? (
            <>
              {"Referencia: " + capitalize(data?.originReferencePoint)}
              <br />
            </>
          ) : (
            ""
          )}
          Ciudad: {capitalize(data?.originCity?.name)}
          <br />
          Estado: {capitalize(data?.originState?.name)}
          {/* <br />-<b>*CÓDIGO DE PRODUCTO*</b>: XXXXXXXXX */}
          <br />-<b>*OPERADOR*</b>:
          {capitalize(data?.user?.firstName) +
            " " +
            capitalize(data?.user?.lastName)}
          {data?.lastService?.code && (
            <>
              <br />
              <b>-*CÓDIGO DE SERVICIO*:</b> {exists(data?.lastService?.code)}
            </>
          )}
          <br />-<b>*{providerLabel}*</b>: {providerValue}
          <br />-<b>*SERVICIO SOLICITADO*</b>:
          {" " + requestedService}{" "}
          {data?.thirdPartyParticularCustomerName && (
            <b> (AV EXTENDIDO - SERVICIO A TERCERO)</b>
          )}
          <br />
          <br />
          <b>*POR FAVOR RECUERDA QUE NO SE DEBE PEDIR LA UBICACIÓN AL CLIENTE*</b>
        </p>

        <CopyButton text={smsText.greenGroup(data, provider, service, _case)} />
      </div>
    </div>
  );
};
export const MessageComponent2 = (props) => {
  const { data, provider } = props;

  if (data?.status === enumStatus?.INITIATED && data?.caseType !== "Alianza") {
    return null;
  }

  return (
    <div>
      <h5 style={{ textAlign: "center" }}>Mensaje a cliente</h5>
      <div className="modal-message-container">
        <p>
          Ya tienes un asistente vial asignado✅
          <br />
          Datos del motorizado:
          <br />
          <br />
          <b>*Nombre: {exists(provider?.contactName)} *</b> <br />
          <b>*Número de contacto: {exists(provider?.phonePrefix)}-{exists(provider?.phoneNumber)} *</b> <br />
          {data?.lastStage?.name !== enumStatus?.SCHEDULED ? (
            <>
              <b>*Tiempo de espera estimado: 25 minutos *</b>
              <br />
            </>
          ) : (
            <>
              <br />
              {`⏰SERVICIO AGENDADO PARA ${data?.scheduleDate &&
                moment(data?.scheduleDate).format(`DD/MM/YYYY`)
                } a las ${data?.scheduleDate && moment(data?.scheduleDate).format(`LT`)
                }`}
              <br />
            </>
          )}
          <br />
          Procura mantenerte en el lugar indicado para que nuestro asistente
          pueda ubicarte 🏍️🚨
          <br />
          <br />
          {data?.lastStage?.name !== enumStatus?.SCHEDULED && (
            <>
              Podrás hacer seguimiento a tu asistente vial asignado a través de
              este link:
              <br />
              <br />
              <a
                href={window.location.origin + `/following-link/${data?._id}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#007bff", textDecoration: "underline" }}
              >
                {window.location.origin + `/following-link/${data?._id}`}
              </a>
              <br />
            </>
          )}
          <br />
          <br />
        </p>
        <CopyButton text={smsText.messageToClient(data, provider)} />
      </div>
    </div>
  );
};

export const MessageComponent3 = (props) => {
  const { data, provider, service } = props;

  return (
    <di>
      <h5 style={{ textAlign: "center" }}>Grupo Amarillo</h5>

      <div className="modal-message-container">
        <p>
          <b>
            *SERVICIO DE TU/GRUERO{" "}
            {data?.thirdPartyParticularCustomerName && "(NO SOLVENTAR AVERIA)"}*{" "}
            {data?.particularCustomer?._id && " Particular"}
          </b>
          <br />-<b>*FECHA DE CREACIÓN*</b>:{" "}
          {moment(data?.createdAt).format("DD/MM/YYYY")}{" "}
          {moment(data?.createdAt).format("LT")}
          {data?.scheduleDate ? (
            <>
              <br />-<b>*FECHA DE SERVICIO*</b>:{" "}
              {moment(data?.scheduleDate).format("DD/MM/YYYY")}{" "}
              {moment(data?.scheduleDate).format("LT")}
            </>
          ) : (
            <>
              <br />-<b>*FECHA DE SERVICIO*</b>:{" "}
              {moment(data?.createdAt).format("DD/MM/YYYY")}{" "}
              {moment(data?.createdAt).format("LT")}
            </>
          )}{" "}
          <br />
          <b>-*AVERÍA*:</b> {capitalize(data?.fault?.description)}
          <br />-<b>*COMENTARIO AVERÍA*</b>:{" "}
          {capitalize(
            data?.customerFailureDescription
              ? data?.customerFailureDescription
              : "Ninguno"
          )}
          <br />-<b>*VEHICULO*</b>:{" "}
          {capitalize(
            data?.thirdPartyVehicleBrand?.brand ||
            data?.particularCustomer?.vehicleBrand?.brand ||
            data?.membership?.vehicle?.brand ||
            data?.vehicleData?.brand?.brand
          ) +
            " " +
            capitalize(
              data?.thirdPartyVehicleModel?.model ||
              data?.particularCustomer?.vehicleModel?.model ||
              data?.membership?.vehicle?.model ||
              data?.vehicleData?.model?.model
            ) +
            " " +
            capitalize(
              data?.thirdPartyVehicleYear ||
              data?.particularCustomer?.vehicleYear ||
              data?.membership?.vehicle?.year ||
              data?.vehicleData?.year
            ) +
            " " +
            capitalize(
              data?.thirdPartyVehicleColor ||
              data?.particularCustomer?.vehicleColor ||
              data?.membership?.vehicle?.color ||
              data?.vehicleData?.color
            )}{" "}
          <br />
          <b>-*PLACA*:</b>{" "}
          {exists(
            data?.thirdPartyVehiclePlate ||
            data?.particularCustomer?.vehiclePlate ||
            data?.membership?.vehicle?.plate ||
            data?.vehicleData?.plate
          )}
          <br />
          <b>-*TELÉFONO*:</b>
          {[
            caseType.AFFILIATED,
            caseType.PARTICULAR,
            caseType.PRIMARY_CARE,
          ].includes(data?.caseType) && (
              <>
                {" " +
                  exists(
                    data?.thirdPartyServicePhonePrefix ||
                    data?.contactNumberPrefix
                  ) +
                  exists(
                    data?.thirdPartyServicePhoneNumber || data?.contactNumber
                  )}
              </>
            )}
          {[caseType.ALLY].includes(data?.caseType) && (
            <>
              {exists(data?.vehicleData.phonePrefix) +
                exists(data?.vehicleData.phoneNumber)}
            </>
          )}
          <br />-<b>*ORIGEN*</b>:{capitalize(data?.originAddress)}
          <br />
          {data?.originReferencePoint ? (
            <>
              {"Referencia: " + capitalize(data?.originReferencePoint)}
              <br />
            </>
          ) : (
            ""
          )}
          Ciudad: {capitalize(data?.originCity?.name)}
          <br />
          Estado: {capitalize(data?.originState?.name)}
          <br />
          {data?.destinyState && (
            <>
              -<b>*DESTINO*</b>:{capitalize(data?.destinyAddress)}
              <br />
              {data?.destinyReferencePoint ? (
                <>
                  {"Referencia: " + capitalize(data?.destinyReferencePoint)}
                  <br />
                </>
              ) : (
                ""
              )}
              Ciudad: {capitalize(data?.destinyCity?.name)}
              <br />
              Estado: {capitalize(data?.destinyState?.name)}
            </>
          )}
          {data?.lastService?.provider && (
            <>
              <br />
              <b>-*PROVEEDOR*: </b>{" "}
              {capitalize(data?.lastService?.provider?.contactName)}
            </>
          )}
          {data?.lastService?.price && (
            <>
              <br />
              <b>-*COSTO DE PROVEEDOR*: </b>{" "}
              {exists(data?.lastService?.price) + "$"}
            </>
          )}
          {data?.caseKm > 0 && (
            <>
              <br />
              <b>-*KILOMETRAJE*:</b> {exists(data?.caseKm) + " Km"}
            </>
          )}
          <br />-<b>*DOMICILIO*</b>:{" "}
          {capitalize(data?.membership?.vehicle?.city) + ", "}
          {capitalize(data?.membership?.vehicle?.state)}
          <br />-<b>*CANTIDAD DE CASOS*</b>:{" "}
          {data?.membership?.towServices?.length}
          <br />-<b>*OPERADOR*</b>:
          {capitalize(data?.user?.firstName) +
            " " +
            capitalize(data?.user?.lastName)}
          {data?.lastService?.code && (
            <>
              <br />
              <b>-*CÓDIGO DE SERVICIO*:</b> {exists(data?.lastService?.code)}
            </>
          )}
          {data?.membership?.code && (
            <>
              <br />
              <b>-*CÓDIGO DE PRODUCTO*:</b>
              {" " +
                exists(data?.membership?.code?.prefixCode) +
                "-" +
                exists(data?.membership?.saleChannel?.shortName) +
                "-" +
                exists(data?.membership?.membershipId)}
            </>
          )}
          {/* <br />
        <b>-*CÓDIGO DE PRODUCTO*:</b> TGP-OFIC-14310 */}
          {/* <br />
        <b>-*VIGENCIA*:</b> 13/06/2021-13/06/2022
        <br />
        <b>-*DOMICILIO*:</b> Miranda
        <br />
        <b>-*CANT DE SERVICIOS*:</b> 0
        <br />
        <b>-*CLIENTE*:</b> Nuevo
        <br /> */}
          <br />
          <b>-*OPERADOR*: </b>{" "}
          {capitalize(data?.user?.firstName) +
            " " +
            capitalize(data?.user?.lastName)}
          <br />-<b>*SERVICIO SOLICITADO*</b>:
          {" " +
            capitalize(
              service?.product || data?.lastService?.product?.name
            )}{" "}
          {data?.thirdPartyParticularCustomerName && (
            <b> (AV EXTENDIDO - SERVICIO A TERCERO)</b>
          )}
          {/* <br />
        <br />
        <b>*SERVICIOS ANTERIORES*:</b> */}
        </p>
        <CopyButton text={smsText.yellowGroup(data, provider, service)} />
      </div>
    </di>
  );
};

export const MessageComponent4 = (props) => {
  const { data } = props;

  return (
    <div>
      <h5 style={{ textAlign: "center" }}>Difusión grueros propios</h5>
      <div className="modal-message-container modal-internal-message-container">
        <p>
          <b>*SERVICIO DE TU/GRUERO*</b>
          <br />
          <br />-<b>*FECHA DE CREACIÓN*</b>:{" "}
          {moment(data?.createdAt).format("DD/MM/YYYY")}{" "}
          {moment(data?.createdAt).format("LT")}
          {data?.scheduleDate ? (
            <>
              <br />-<b>*FECHA DE SERVICIO*</b>:{" "}
              {moment(data?.scheduleDate).format("DD/MM/YYYY")}{" "}
              {moment(data?.scheduleDate).format("LT")}
            </>
          ) : (
            <>
              <br />-<b>*FECHA DE SERVICIO*</b>:{" "}
              {moment(data?.createdAt).format("DD/MM/YYYY")}{" "}
              {moment(data?.createdAt).format("LT")}
            </>
          )}{" "}
          <br />-<b>*AVERÍA*</b>: {capitalize(data?.fault?.description)}
          <br />-<b>*COMENTARIO AVERÍA*</b>:{" "}
          {capitalize(
            data?.customerFailureDescription
              ? data?.customerFailureDescription
              : "Ninguno"
          )}
          <br />-<b>*VEHICULO*</b>:{" "}
          {capitalize(
            data?.thirdPartyVehicleBrand?.brand ||
            data?.particularCustomer?.vehicleBrand?.brand ||
            data?.membership?.vehicle?.brand ||
            data?.vehicleData?.brand?.brand
          ) +
            " " +
            capitalize(
              data?.thirdPartyVehicleModel?.model ||
              data?.particularCustomer?.vehicleModel?.model ||
              data?.membership?.vehicle?.model ||
              data?.vehicleData?.model?.model
            ) +
            " " +
            capitalize(
              data?.thirdPartyVehicleYear ||
              data?.particularCustomer?.vehicleYear ||
              data?.membership?.vehicle?.year ||
              data?.vehicleData?.year
            ) +
            " " +
            capitalize(
              data?.thirdPartyVehicleColor ||
              data?.particularCustomer?.vehicleColor ||
              data?.membership?.vehicle?.color ||
              data?.vehicleData?.color
            )}
          <br />-<b>*ORIGEN*</b>:{capitalize(data?.originAddress)}
          <br />
          {data?.originReferencePoint ? (
            <>
              {"Referencia: " + capitalize(data?.originReferencePoint)}
              <br />
            </>
          ) : (
            ""
          )}
          Ciudad: {capitalize(data?.originCity?.name)}
          <br />
          Estado: {capitalize(data?.originState?.name)}
          <br />
          {/* {data?.destinyState && (
            <>
              -<b>*DESTINO*</b>:{capitalize(data?.destinyAddress)}
              <br />
              {data?.destinyReferencePoint ? (
                <>
                  {"Referencia: " + capitalize(data?.destinyReferencePoint)}
                  <br />
                </>
              ) : (
                ""
              )}
              Ciudad: {capitalize(data?.destinyCity?.name)}
              <br />
              Estado: {capitalize(data?.destinyState?.name)}
            </>
          )} */}
          <br />
          {/* {data?.caseKm && (
            <>
              <b>-*DISTANCIA*: </b> {exists(data?.caseKm) + " Km"}
            </>
          )}
          <br />
          <br /> */}
          <b>*Interesados responder con el precio y el tiempo de espera*</b>
        </p>
        <CopyButton text={smsText.towBroadcastInternalMessage(data)} />
      </div>
    </div>
  );
};

export const MessageComponent8 = (props) => {
  const { data } = props;

  return (
    <div>
      <h5 style={{ textAlign: "center" }}>Difusión grueros externos</h5>
      <div className="modal-message-container">
        <p>
          <b>*SERVICIO DE TU/GRUERO*</b>
          <br />
          <br />-<b>*FECHA DE CREACIÓN*</b>:{" "}
          {moment(data?.createdAt).format("DD/MM/YYYY")}{" "}
          {moment(data?.createdAt).format("LT")}
          {data?.scheduleDate ? (
            <>
              <br />-<b>*FECHA DE SERVICIO*</b>:{" "}
              {moment(data?.scheduleDate).format("DD/MM/YYYY")}{" "}
              {moment(data?.scheduleDate).format("LT")}
            </>
          ) : (
            <>
              <br />-<b>*FECHA DE SERVICIO*</b>:{" "}
              {moment(data?.createdAt).format("DD/MM/YYYY")}{" "}
              {moment(data?.createdAt).format("LT")}
            </>
          )}{" "}
          <br />-<b>*AVERÍA*</b>: {capitalize(data?.fault?.description)}
          <br />-<b>*COMENTARIO AVERÍA*</b>:{" "}
          {capitalize(
            data?.customerFailureDescription
              ? data?.customerFailureDescription
              : "Ninguno"
          )}
          <br />-<b>*VEHICULO*</b>:{" "}
          {capitalize(
            data?.thirdPartyVehicleBrand?.brand ||
            data?.particularCustomer?.vehicleBrand?.brand ||
            data?.membership?.vehicle?.brand ||
            data?.vehicleData?.brand?.brand
          ) +
            " " +
            capitalize(
              data?.thirdPartyVehicleModel?.model ||
              data?.particularCustomer?.vehicleModel?.model ||
              data?.membership?.vehicle?.model ||
              data?.vehicleData?.model?.model
            ) +
            " " +
            capitalize(
              data?.thirdPartyVehicleYear ||
              data?.particularCustomer?.vehicleYear ||
              data?.membership?.vehicle?.year ||
              data?.vehicleData?.year
            ) +
            " " +
            capitalize(
              data?.thirdPartyVehicleColor ||
              data?.particularCustomer?.vehicleColor ||
              data?.membership?.vehicle?.color ||
              data?.vehicleData?.color
            )}
          <br />-<b>*ORIGEN*</b>:{capitalize(data?.originAddress)}
          <br />
          {data?.originReferencePoint ? (
            <>
              {"Referencia: " + capitalize(data?.originReferencePoint)}
              <br />
            </>
          ) : (
            ""
          )}
          Ciudad: {capitalize(data?.originCity?.name)}
          <br />
          Estado: {capitalize(data?.originState?.name)}
          <br />
          {data?.destinyState && (
            <>
              -<b>*DESTINO*</b>:{capitalize(data?.destinyAddress)}
              <br />
              {data?.destinyReferencePoint ? (
                <>
                  {"Referencia: " + capitalize(data?.destinyReferencePoint)}
                  <br />
                </>
              ) : (
                ""
              )}
              Ciudad: {capitalize(data?.destinyCity?.name)}
              <br />
              Estado: {capitalize(data?.destinyState?.name)}
            </>
          )}
          <br />
          {data?.caseKm > 0 && (
            <>
              <b>-*DISTANCIA*: </b> {exists(data?.caseKm) + " Km"}
            </>
          )}
          <br />
          <b>*Interesados responder con el precio y el tiempo de espera*</b>
        </p>
        <CopyButton text={smsText.towBroadcastExternalMessage(data)} />
      </div>
    </div>
  );
};

export const MessageComponent5 = (props) => {
  const { data } = props;
  return (
    <div className="modal-message-container">
      <p>
        <b>*POR FAVOR RECUERDA QUE NO SE DEBE PEDIR LA UBICACIÓN AL CLIENTE*</b>
        <br />
        <br />
        <b>*SERVICIO DE TU/GRUERO*</b>
        <br />-<b>*FECHA DE CREACIÓN*</b>:{" "}
        {moment(data?.createdAt).format("DD/MM/YYYY")}{" "}
        {moment(data?.createdAt).format("LT")}
        {data?.scheduleDate ? (
          <>
            <br />-<b>*FECHA DE SERVICIO*</b>:{" "}
            {moment(data?.scheduleDate).format("DD/MM/YYYY")}{" "}
            {moment(data?.scheduleDate).format("LT")}
          </>
        ) : (
          <>
            <br />-<b>*FECHA DE SERVICIO*</b>:{" "}
            {moment(data?.createdAt).format("DD/MM/YYYY")}{" "}
            {moment(data?.createdAt).format("LT")}
          </>
        )}
        <br />-<b>*CLIENTE*</b>:{" "}
        {capitalize(
          data?.particularCustomer?.firstName ||
          data?.membership?.customer?.firstName ||
          data?.vehicleData?.firstName
        ) +
          " " +
          capitalize(
            data?.particularCustomer?.lastName ||
            data?.membership?.customer?.lastName ||
            data?.vehicleData?.lastName
          )}
        <br />-<b>*TELÉFONO*</b>:{" "}
        {[
          caseType.AFFILIATED,
          caseType.PARTICULAR,
          caseType.PRIMARY_CARE,
        ].includes(data?.caseType) && (
            <>
              {" " +
                exists(
                  data?.thirdPartyServicePhonePrefix || data?.contactNumberPrefix
                ) +
                exists(data?.thirdPartyServicePhoneNumber || data?.contactNumber)}
            </>
          )}
        {[caseType.ALLY].includes(data?.caseType) && (
          <>
            {exists(data?.vehicleData.phonePrefix) +
              exists(data?.vehicleData.phoneNumber)}
          </>
        )}
        <br />-<b>*PLACA*</b>:{" "}
        {exists(
          data?.particularCustomer?.vehiclePlate ||
          data?.membership?.vehicle?.plate ||
          data?.vehicleData?.plate
        )}
        <br />-<b>*VEHICULO*</b>:{" "}
        {capitalize(
          data?.particularCustomer?.vehicleBrand?.brand ||
          data?.membership?.vehicle?.brand ||
          data?.vehicleData?.brand?.brand
        ) +
          " " +
          capitalize(
            data?.particularCustomer?.vehicleModel?.model ||
            data?.membership?.vehicle?.model ||
            data?.vehicleData?.model?.model
          ) +
          " " +
          capitalize(
            data?.particularCustomer?.vehicleYear ||
            data?.membership?.vehicle?.year ||
            data?.vehicleData?.year
          ) +
          " " +
          capitalize(
            data?.particularCustomer?.vehicleColor ||
            data?.membership?.vehicle?.color ||
            data?.vehicleData?.color
          )}
        <br />-<b>*AVERÍA*</b>: {capitalize(data?.fault?.description)}
        <br />-<b>*COMENTARIO AVERÍA*</b>:{" "}
        {capitalize(
          data?.customerFailureDescription
            ? data?.customerFailureDescription
            : "Ninguno"
        )}
        <br />-<b>*ORIGEN*</b>:{capitalize(data?.originAddress)}
        <br />
        {data?.originReferencePoint ? (
          <>
            {"Referencia: " + capitalize(data?.originReferencePoint)}
            <br />
          </>
        ) : (
          ""
        )}
        Ciudad: {capitalize(data?.originCity?.name)}
        <br />
        Estado: {capitalize(data?.originState?.name)}
        <br />
        {data?.destinyState && (
          <>
            -<b>*DESTINO*</b>:{capitalize(data?.destinyAddress)}
            <br />
            {data?.destinyReferencePoint ? (
              <>
                {"Referencia: " + capitalize(data?.destinyReferencePoint)}
                <br />
              </>
            ) : (
              ""
            )}
            Ciudad: {capitalize(data?.destinyCity?.name)}
            <br />
            Estado: {capitalize(data?.destinyState?.name)}
          </>
        )}
        {data?.caseKm && (
          <>
            <br /> - <b>*DISTANCIA*: </b> {exists(data?.caseKm)}Km
          </>
        )}
        <br />-<b>*OPERADOR* </b>:
        {capitalize(data?.user?.firstName) +
          " " +
          capitalize(data?.user?.lastName)}
        {data?.lastService?.code && (
          <>
            <br />
            <b>-*CÓDIGO DE SERVICIO*: </b> {exists(data?.lastService?.code)}
          </>
        )}
        {data?.lastService?.price && (
          <>
            <br />
            <b>-*COSTO DE PROVEEDOR*: </b>{" "}
            {exists(data?.lastService?.price) + "$"}
          </>
        )}
        {/* <br />-<b>*CÓDIGO DE PRODUCTO*</b>: XXXXXXXXX */}
        <br />
        <br />
        <b>
          Estimado Gruero por favor llamar al cliente e indicarle al mismo
          Marca, Modelo, Color de la grua que le asistirá.
        </b>
        <br />
        <br />
        <b>
          SE SOLICITA POR FAVOR QUE AL TOMAR EL SERVICIO NOS ENVÍEN 3 FOTOS, AL
          SUBIRLO A LA GRÚA, SOBRE LA GRÚA Y AL BAJARLO DE LA GRÚA. RECUERDE QUE
          EL CÓDIGO DEL SERVICIO DEBE ESTAR REFLEJADO EN LA FACTURA.
        </b>
        <br />
        <br />
        <b>*POR FAVOR RECUERDA QUE NO SE DEBE PEDIR LA UBICACIÓN AL CLIENTE*</b>
      </p>

      <CopyButton text={smsText.towMesage(data)} />
    </div>
  );
};

export const CreateSalesUserModal = (props) => {
  const {
    reset,
    onChange,
    modal,
    handleModal,
    register,
    errors,
    action,
    options,
    watch,
  } = props;

  const close = () => {
    handleModal();
    reset();
  };

  return (
    <Modal size="lg" centered show={modal?.isOpen} onHide={() => close()}>
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h5>Nuevo Usuario</h5>
        <CreateSalesUserForm
          register={register}
          errors={errors}
          action={action}
          cancel={() => close()}
          options={options}
          onChange={onChange}
          watch={watch}
        />
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const CreateAllyModal = (props) => {
  const { modal } = props;

  return (
    <Modal
      size="lg"
      centered
      show={modal?.show}
      onHide={() => modal.form.cancel()}
    >
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h5>Nueva Alianza</h5>
        <CreateAllyForm modal={modal} />
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const BlockAllyModal = (props) => {
  const { show, action, cancel } = props;

  return (
    <Modal size="lg" centered show={show} onHide={() => cancel()}>
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h5>¿Estas seguro de que deseas continuar?</h5>
        <br />
        <BlockAllyForm action={action} cancel={cancel} />
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const EditSalesUserModal = (props) => {
  const {
    reset,
    onChange,
    modal,
    handleModal,
    register,
    errors,
    action,
    options,
  } = props;

  const close = () => {
    handleModal();
    reset();
  };

  return (
    <Modal size="lg" centered show={modal?.isOpen} onHide={() => close()}>
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h5>Nuevo Usuario</h5>
        <EditSalesUserForm
          register={register}
          errors={errors}
          action={action}
          cancel={() => close()}
          options={options}
          onChange={onChange}
        />
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const MessageComponent6 = (props) => {
  const { data } = props;
  return (
    <div className="modal-message-container">
      <p>
        <b>*SERVICIO DE TU/GRUERO*</b>
        <br />-<b>*FECHA DE CREACIÓN*</b>:{" "}
        {moment(data?.createdAt).format("DD/MM/YYYY")}{" "}
        {moment(data?.createdAt).format("LT")}
        {data?.scheduleDate ? (
          <>
            <br />-<b>*FECHA DE SERVICIO*</b>:{" "}
            {moment(data?.scheduleDate).format("DD/MM/YYYY")}{" "}
            {moment(data?.scheduleDate).format("LT")}
          </>
        ) : (
          <>
            <br />-<b>*FECHA DE SERVICIO*</b>:{" "}
            {moment(data?.createdAt).format("DD/MM/YYYY")}{" "}
            {moment(data?.createdAt).format("LT")}
          </>
        )}{" "}
        <br />-<b>*CLIENTE*</b>:{" "}
        {capitalize(
          data?.particularCustomer?.firstName ||
          data?.membership?.customer?.firstName ||
          data?.vehicleData?.firstName
        ) +
          " " +
          capitalize(
            data?.particularCustomer?.lastName ||
            data?.membership?.customer?.lastName ||
            data?.vehicleData?.lastName
          )}
        <br />-<b>*TELÉFONO*</b>:{" "}
        {[
          caseType.AFFILIATED,
          caseType.PARTICULAR,
          caseType.PRIMARY_CARE,
        ].includes(data?.caseType) && (
            <>
              {" " +
                exists(
                  data?.thirdPartyServicePhonePrefix || data?.contactNumberPrefix
                ) +
                exists(data?.thirdPartyServicePhoneNumber || data?.contactNumber)}
            </>
          )}
        {[caseType.ALLY].includes(data?.caseType) && (
          <>
            {exists(data?.vehicleData.phonePrefix) +
              exists(data?.vehicleData.phoneNumber)}
          </>
        )}
        <br />-<b>*PLACA*</b>:{" "}
        {exists(
          data?.particularCustomer?.vehiclePlate ||
          data?.membership?.vehicle?.plate ||
          data?.vehicleData?.plate
        )}
        <br />-<b>*VEHICULO*</b>:{" "}
        {capitalize(
          data?.particularCustomer?.vehicleBrand?.brand ||
          data?.membership?.vehicle?.brand ||
          data?.vehicleData?.brand?.brand
        ) +
          " " +
          capitalize(
            data?.particularCustomer?.vehicleModel?.model ||
            data?.membership?.vehicle?.model ||
            data?.vehicleData?.model?.model
          ) +
          " " +
          capitalize(
            data?.particularCustomer?.vehicleYear ||
            data?.membership?.vehicle?.year ||
            data?.vehicleData?.year
          ) +
          " " +
          capitalize(
            data?.particularCustomer?.vehicleColor ||
            data?.membership?.vehicle?.color ||
            data?.vehicleData?.color
          )}
        <br />-<b>*AVERÍA*</b>: {capitalize(data?.fault?.description)}
        <br />-<b>*ORIGEN*</b>:{capitalize(data?.originAddress)}
        <br />
        {data?.originReferencePoint ? (
          <>
            {"Referencia: " + capitalize(data?.originReferencePoint)}
            <br />
          </>
        ) : (
          ""
        )}
        Ciudad: {capitalize(data?.originCity?.name)}
        <br />
        Estado: {capitalize(data?.originState?.name)}
        <br />
        {data?.destinyState && (
          <>
            -<b>*DESTINO*</b>:{capitalize(data?.destinyAddress)}
            <br />
            {data?.destinyReferencePoint ? (
              <>
                {"Referencia: " + capitalize(data?.destinyReferencePoint)}
                <br />
              </>
            ) : (
              ""
            )}
            Ciudad: {capitalize(data?.destinyCity?.name)}
            <br />
            Estado: {capitalize(data?.destinyState?.name)}
          </>
        )}
        {data?.membership?.beginDate && data?.membership?.endDate && (
          <>
            <br /> - <b>*DISTANCIA*: </b> {exists(data?.caseKm)}Km
          </>
        )}
        {data?.services?.length > 0 &&
          data?.services[0]?.type === "Asistencia vial" && (
            <>
              <br /> - <b>*VERIFICADO POR:*</b>{" "}
              {data?.services[0]?.provider?.contactName}
            </>
          )}
        {data?.services?.length > 0 && data?.services[0]?.type === "Grua" && (
          <>
            <br /> - <b>*VERIFICADO POR:*</b> Servicio de grúa directo
          </>
        )}
        {data?.lastService?.provider && (
          <>
            <br />
            <b>-*PROVEEDOR*: </b>{" "}
            {capitalize(data?.lastService?.provider?.contactName)}
          </>
        )}
        {data?.lastService?.price && (
          <>
            <br />
            <b>-*COSTO DE PROVEEDOR*: </b>{" "}
            {exists(data?.lastService?.price) + "$"}
          </>
        )}
        {data?.membership?.customer?.homeCity && (
          <>
            <br /> - <b>*DOMICILIO*: </b>
            {capitalize(data?.membership?.customer?.homeState) + " "}
            {capitalize(data?.membership?.customer?.homeCity) + " "}
            {capitalize(data?.membership?.customer?.homeMunicipality) + " "}
            {capitalize(data?.membership?.customer?.homeAddress)}
          </>
        )}
        {data?.membership?.beginDate && (
          <>
            <br /> - <b>*VIGENCIA*: </b>{" "}
            {exists(moment(data?.membership?.beginDate).format("DD/MM/YYYY"))}-
            {exists(moment(data?.membership?.endDate).format("DD/MM/YYYY"))}
          </>
        )}
        <br />-<b>*DOMICILIO*</b>:{" "}
        {capitalize(data?.membership?.vehicle?.city) + ", "}
        {capitalize(data?.membership?.vehicle?.state)}
        <br />-<b>*CANTIDAD DE CASOS*</b>:{" "}
        {data?.membership?.towServices?.length}
        <br />-<b>*OPERADOR*</b>:
        {capitalize(data?.user?.firstName) +
          " " +
          capitalize(data?.user?.lastName)}
        {data?.lastService?.code && (
          <>
            <br />
            <b>-*CÓDIGO DE SERVICIO*:</b> {exists(data?.lastService?.code)}
          </>
        )}
        {data?.membership?.code && (
          <>
            <br />
            <b>-*CÓDIGO DE PRODUCTO*:</b>
            {" " +
              exists(data?.membership?.code?.prefixCode) +
              "-" +
              exists(data?.membership?.saleChannel?.shortName) +
              "-" +
              exists(data?.membership?.membershipId)}
          </>
        )}
      </p>

      <CopyButton text={smsText.towServiceMessage(data)} />
    </div>
  );
};

export const MessageComponent7 = (props) => {
  const { data, provider } = props;
  return (
    <div className="modal-message-container">
      <p>
        Ya tienes un gruero asignado✅
        <br />
        Datos del gruero:
        <br />
        <br />
        <b>*Nombre: {exists(provider?.contactName)} *</b>
        <b>*Número de contacto: {exists(provider?.phonePrefix)}-{exists(provider?.phoneNumber)} *</b>
        <br />
        {data?.lastStage?.name !== enumStatus?.TOW_ASSIGNED && (
          <>
            <b>*Tiempo de espera estimado: 45 minutos *</b>
            <br />
          </>
        )}
        {data?.lastStage?.name === enumStatus?.TOW_ASSIGNED &&
          data?.scheduleDate && (
            <>
              <br />
              <br />
              {`⏰SERVICIO AGENDADO PARA ${data?.scheduleDate &&
                moment(data?.scheduleDate).format(`DD/MM/YYYY`)
                } a las ${data?.scheduleDate && moment(data?.scheduleDate).format(`LT`)
                }`}
              <br />
            </>
          )}
        <br />
        Procura mantenerte en el lugar indicado para que nuestro asistente pueda
        ubicarte 🏍️🚨
        <br />
        {(((data?.scheduleDate &&
          ![enumStatus?.SEARCHING_TOW, enumStatus?.TOW_ASSIGNED].includes(
            data?.lastStage?.name
          )) ||
          (!data?.scheduleDate &&
            ![enumStatus?.SEARCHING_TOW].includes(data?.lastStage?.name))) &&
          provider?.isInternal !== false) && (
            <>
              <br />
              Podrás hacer seguimiento a tu gruero asignado a través de este link:
              <br />
              <br />
              <a
                href={window.location.origin + `/following-link/${data?._id}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#007bff", textDecoration: "underline" }}
              >
                {window.location.origin + `/following-link/${data?._id}`}
              </a>
            </>
          )}
        <br />
        <br />
      </p>
      <CopyButton text={smsText.messageLinkToClient(data, provider)} />
    </div>
  );
};

export const MessageTowModal = (props) => {
  const { showSMSModal, handleClose, caseInfo, action } = props;

  let stage = "";

  switch (caseInfo?.lastStage?.name) {
    case enumStatus?.SEARCHING_TOW:
      stage = towSMSEnum?.SEARCHING_TOW;
      break;
    case enumStatus?.TOW_ASSIGNED:
      stage = towSMSEnum?.ASSIGNED_TOW;
      break;
    case undefined:
      stage = towSMSEnum?.FORM;
      break;
    default:
      stage = towSMSEnum?.ASSIGNED_TOW;
      break;
  }

  const validateIfFollowingLink = () => {
    if ([enumStatus.SEARCHING_TOW].includes(caseInfo?.lastStage?.name)) {
      return false;
    } else return true;
  };
  return (
    <Modal
      size="xl"
      centered
      show={showSMSModal?.isOpen}
      onHide={() => handleClose(false)}
    >
      <Modal.Header className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h4>Mensajes de selección de grueros</h4>
        <div className="modal-messages-container">
          {[towSMSEnum?.ASSIGNED_TOW].includes(stage) && (
            <div className="sms-modal-text-container ">
              <h5>Aprobación de Grueros</h5>
              <MessageComponent5
                data={caseInfo}
                provider={showSMSModal?.provider}
              />
            </div>
          )}

          {validateIfFollowingLink() && (
            <div className="sms-modal-text-container ">
              <h5>Mensaje a Cliente</h5>
              <MessageComponent7
                data={caseInfo}
                provider={showSMSModal?.provider}
              />
            </div>
          )}

          {[towSMSEnum?.SEARCHING_TOW, towSMSEnum?.ASSIGNED_TOW].includes(
            stage
          ) && (
              <div className="sms-modal-text-container ">
                <h5>Grupo Amarillo</h5>
                <MessageComponent6
                  data={caseInfo}
                  provider={showSMSModal?.provider}
                />
              </div>
            )}
          {[towSMSEnum?.FORM, towSMSEnum?.SEARCHING_TOW].includes(stage) && (
            <div className="sms-modal-text-container ">
              <MessageComponent4
                data={caseInfo}
                provider={showSMSModal?.provider}
              />
            </div>
          )}
          {[towSMSEnum?.FORM, towSMSEnum?.SEARCHING_TOW].includes(stage) && (
            <div className="sms-modal-text-container ">
              <MessageComponent8
                data={caseInfo}
                provider={showSMSModal?.provider}
              />
              <div className="amount-baremo-container">
                <p>
                  Monto de grua externa segun Baremo:{" "}
                  {caseInfo?.priceDetails?.externalFinalPrice}$
                </p>
              </div>
            </div>
          )}
          {caseInfo?.taxi &&
            <div className="sms-modal-text-container ">
              <MessageComponentTaxi
                data={caseInfo}
                provider={showSMSModal?.provider}
              />
            </div>
          }
        </div>

        <div className="buttons-center-container">
          <AltButton label={"Cerrar"} action={() => handleClose(false)} />{" "}
          {action && <AltButton label={"Continuar"} action={() => action()} />}
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const MessageComponentTaxi = (props) => {
  const { data, } = props;
  return (
    <div>
      <h5 style={{ textAlign: "center" }}>Mensaje de Taxi</h5>
      <div className="modal-message-container">
        <p>
          <b>
            *¡Tu tranquilidad es nuestra prioridad! 🚗✨*{" "}
          </b>
          <br />
          <br />
          <p>Sabemos que los imprevistos en la vía son estresantes, especialmente si viajas acompañado. Para que todos lleguen a su destino con comodidad, te obsequiamos un código de descuento en <b>Ridery:</b></p>
          <br />
          🎫 Código: <b>{exists(data?.taxi)}</b> 💰 Beneficio: $2 de descuento en traslados de hasta $15.
          <br />
          <br />
          <b>Válido para un solo uso. ¡Buen viaje!</b>
        </p>
        <CopyButton text={smsText.taxiMessage(data)} />
      </div>
    </div>
  );
};

export const MessageTaxiModal = (props) => {
  const { showSMSModal, handleClose, caseInfo } = props;

  return (
    <Modal
      size="xl"
      centered
      show={showSMSModal?.isOpen}
      onHide={() => handleClose(false)}
    >
      <Modal.Header className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <div className="modal-messages-container">
          <div className="sms-modal-text-container">
            <MessageComponentTaxi
              data={caseInfo}
              provider={showSMSModal?.provider}
            />
          </div>
        </div>
        <div className="buttons-center-container">
          <AltButton label={"Cerrar"} action={() => handleClose(false)} />
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const ProviderDetailModal = (props) => {
  const { show, handleClose, action } = props;

  return (
    <Modal size="lg" centered show={show} onHide={() => handleClose(false)}>
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h3>Detalles del Proveedor</h3>
        <br />
        <table className="providers-detail-table">
          <tr>
            <td>
              <b>-Telefonos de Contacto:</b>
            </td>
            <td>02123191250</td>
          </tr>
          <tr>
            <td>
              <b>-Turno:</b>
            </td>
            <td></td>
          </tr>
          <tr>
            <td>
              <b>-Horario de atencion:</b>
            </td>
            <td></td>
          </tr>
          <tr>
            <td>
              <b>-Whee life (de 0 a 3500 Kg):</b>
            </td>
            <td></td>
          </tr>
          <tr>
            <td>
              <b>-Plataforma (de 0 a 5 Tonelada):</b>
            </td>
            <td>1</td>
          </tr>
          <tr>
            <td>
              <b>-Gancho (de 5 Hasta 8 Toneladas):</b>
            </td>
            <td></td>
          </tr>
          <tr>
            <td>
              <b>-Extra Pesado (de 8 hasta 20 Toneladas):</b>
            </td>
            <td></td>
          </tr>
        </table>
        <br />
        <div className="buttons-center-container">
          <AltButton action={() => handleClose(false)} label={"Cancelar"} />
          <ActionButton action={action} label={"Seleccionar"} />
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const ApprovalModal = (props) => {
  const { show, handleClose, action, t, register, errors } = props;

  return (
    <Modal size="lg" centered show={show} onHide={() => handleClose(false)}>
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h3>Se necesita aprobación para continuar el proceso</h3>
        <ApprovalPaymentForm
          t={t}
          register={register}
          errors={errors}
          action={action}
          cancel={() => handleClose(false)}
        />
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const NewIncidenceModal = (props) => {
  const { show, handleClose, particular, afiliated, alliance } = props;

  return (
    <Modal size="lg" centered show={show} onHide={() => handleClose(false)}>
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h3 style={{ marginBottom: "24px" }}>Nueva Incidencia</h3>
        <h6 style={{ margin: "24px" }}>
          Seleccione el tipo de incidencia a crear
        </h6>
      </Modal.Body>
      <div className="buttons-center-container">
        <AltButton action={particular} label={"Cliente Particular"} />
        <ActionButton action={afiliated} label={"Cliente Afiliado"} />
      </div>
      <br />
      <div className="buttons-center-container">
        <AltButton action={alliance} label={"Alianza"} />
      </div>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const MapModal = (props) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: ["places"],
    language: "es",
  });

  const {
    show,
    handleClose,
    origin,
    setOrigin,
    destiny,
    setDestiny,
    route,
    setRoute,
  } = props;

  if (!isLoaded) {
    return null;
  }

  return (
    <Modal size="xl" centered show={show} onHide={() => handleClose(false)}>
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <div className="google-maps-container">
          <Map
            origin={origin}
            setOrigin={setOrigin}
            destiny={destiny}
            setDestiny={setDestiny}
            handleClose={handleClose}
            route={route}
            setRoute={setRoute}
          />
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const LocationMapModal = (props) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: ["places"],
    language: "es",
  });

  const { modal, handleModal } = props;

  if (!isLoaded) {
    return null;
  }

  return (
    <Modal size="xl" centered show={modal?.show} onHide={() => handleModal()}>
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <div className="google-maps-container">
          <LocationMap data={modal?.data} />
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

const DEVICES_LOCATION_POLL_MS = 30 * 1000;

export const AllDevicesMapModal = (props) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: ["places"],
    language: "es",
  });

  const { modal, handleModal, showInfoWindow, refresh, showLegend } = props;
  const [mapReady, setMapReady] = useState(false);
  const refreshRef = useRef(refresh);
  refreshRef.current = refresh;

  useEffect(() => {
    if (!isLoaded || !modal?.show) return;

    const poll = () => {
      if (
        typeof document !== "undefined" &&
        document.visibilityState === "hidden"
      ) {
        return;
      }
      refreshRef.current?.({ silent: true });
    };

    poll();
    const intervalId = setInterval(poll, DEVICES_LOCATION_POLL_MS);

    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        poll();
      }
    };
    document.addEventListener("visibilitychange", onVisibilityChange);

    return () => {
      clearInterval(intervalId);
      document.removeEventListener("visibilitychange", onVisibilityChange);
    };
  }, [isLoaded, modal?.show]);

  if (!isLoaded) {
    return null;
  }

  return (
    <>
      <LoadSpinner
        show={
          Boolean(modal?.show) &&
          Boolean(modal?.devicesLocation?.isLoading) &&
          !modal?.devicesLocation?.data?.length
        }
      />
      <Modal
        fullscreen
        show={modal?.show}
        onHide={() => handleModal(false)}
        onEntered={() => setMapReady(true)}
        onExit={() => setMapReady(false)}
        contentClassName="all-devices-map-modal"
      >
        <Modal.Header closeButton className="modal-header"></Modal.Header>
        <Modal.Body className="modal-body all-devices-map-modal-body">
          <div className="google-maps-container">
            {mapReady && (
              <AllDevicesMap
                data={modal?.devicesLocation?.data}
                refresh={refresh}
                showLegend={showLegend}
                showInfoWindow={showInfoWindow}
              />
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export const SelectServicePaymentModal = (props) => {
  const { modal, handleClose, handlePaymentModal } = props;

  return (
    <Modal
      size="xl"
      centered
      show={modal?.isOpen}
      onHide={() => handleClose(false)}
    >
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h4 style={{ marginBottom: "24px" }}>Seleccione pago a modificar</h4>
        <div className="google-maps-container"></div>

        <table className="table">
          <tr>
            {selectServiceHeader.map((h) => (
              <th key={h?.value}>{h?.name}</th>
            ))}
          </tr>

          {modal?.services.length > 0 &&
            modal?.services.map((d) => (
              <tr key={d?._id}>
                <td>{capitalize(d?.product?.name)}</td>
                <td>
                  {exists(d?.paymentStatus)}{" "}
                  {d?.pendingPayment?.datePaid ? " (Pago realizado) " : " "}
                </td>
                <td>{capitalize(d?.provider?.contactName)}</td>
                <td>{exists(d?.code)}</td>
                <td>{exists(d?.price) + "$"}</td>
                <td>{exists(d?.pvp) + "$"}</td>
                <td>
                  <div className='className="buttons-center-container'>
                    <ActionButton
                      label={"Seleccionar"}
                      action={() => handlePaymentModal(d, false, modal?.incidence)}
                    />
                  </div>
                </td>
              </tr>
            ))}
        </table>
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const SelectCashbackPaymentModal = (props) => {
  const { modal, handleClose, handleCashbackModal } = props;

  return (
    <Modal
      size="xl"
      centered
      show={modal?.isOpen}
      onHide={() => handleClose(false)}
    >
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h4 style={{ marginBottom: "24px" }}>Seleccione vuelto a modificar</h4>
        <div className="google-maps-container"></div>

        <table className="table">
          <tr>
            {selectCashbackHeader.map((h) => (
              <th key={h?.value}>{h?.name}</th>
            ))}
          </tr>

          {modal?.cashbacks.length > 0 &&
            modal?.cashbacks.map((d) => (
              <tr key={d?._id}>
                <td>{d?.paid}</td>
                <td>{capitalize(d?.method?.method)}</td>
                <td>{d?.amount}</td>
                <td>{d?.amountBs}</td>
                <td>
                  {d?.createdAt
                    ? moment(d?.createdAt).format("DD/MM/YYYY")
                    : ""}
                </td>
                <td>{d?.ref}</td>
                <td>
                  {d?.referenceImg && (
                    <a target="_blank" href={d?.referenceImg} rel="noreferrer">
                      Comprobante de vuelto
                    </a>
                  )}
                </td>
                <td>
                  <div className='className="buttons-center-container'>
                    <ActionButton
                      label={"Editar"}
                      action={() => handleCashbackModal(d)}
                    />
                  </div>
                </td>
              </tr>
            ))}
        </table>
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const CreateAVModal = (props) => {
  const {
    show,
    handleClose,
    register,
    createAVService,
    errors,
    options,
    watch,
    onChange,
    fileUploaded,
    setFileUploaded,
    bsDisabled,
    handleDrop,
    cashBackImage,
    removeFile,
    errorsDropzone,
    battery,
    setValue,
    showErrorAPI,
  } = props;

  return (
    <Modal size="xl" centered show={show} onHide={() => handleClose(false)}>
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <div className="google-maps-container"></div>
        <CreateAVForm
          register={register}
          cancel={() => handleClose(false)}
          action={createAVService}
          errors={errors}
          options={options}
          watch={watch}
          onChange={onChange}
          fileUploaded={fileUploaded}
          setFileUploaded={setFileUploaded}
          bsDisabled={bsDisabled}
          handleDrop={handleDrop}
          cashBackImage={cashBackImage}
          removeFile={removeFile}
          errorsDropzone={errorsDropzone}
          battery={battery}
          setValue={setValue}
          showErrorAPI={showErrorAPI}
        />
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const FollowUpModal = (props) => {
  const {
    show,
    handleClose,
    register,
    action,
    edit,
    errors,
    options,
    watch,
    onChange,
    control,
    acceptFollowing,
  } = props;

  return (
    <Modal size="xl" centered show={show} onHide={() => handleClose(false)}>
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <div className="google-maps-container"></div>
        <FollowUpForm
          register={register}
          cancel={() => handleClose(false)}
          action={action}
          edit={edit}
          errors={errors}
          options={options}
          watch={watch}
          onChange={onChange}
          control={control}
          acceptFollowing={acceptFollowing}
        />
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const CreatePaymentModal = (props) => {
  const {
    modal,
    cancel,
    register,
    action,
    errors,
    options,
    control,
    watch,
    onChange,
    fileUploaded,
    setFileUploaded,
    handleDrop,
    cashBackImage,
    removeFile,
    errorsDropzone,
    OTP,
    handleEditPayment,
    setValue,
    showErrorAPI,
  } = props;

  return (
    <Modal size="xl" centered show={modal?.isOpen} onHide={() => cancel()}>
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <div className="google-maps-container"></div>
        <CreatePaymentForm
          register={register}
          cancel={() => cancel()}
          action={action}
          errors={errors}
          options={options}
          watch={watch}
          setValue={setValue}
          modal={modal}
          control={control}
          onChange={onChange}
          fileUploaded={fileUploaded}
          setFileUploaded={setFileUploaded}
          bsDisabled={true}
          handleDrop={handleDrop}
          cashBackImage={cashBackImage}
          removeFile={removeFile}
          errorsDropzone={errorsDropzone}
          handleEditPayment={handleEditPayment}
          OTP={OTP}
          showErrorAPI={showErrorAPI}
        />
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const EditPaymentModal = (props) => {
  const {
    modal,
    cancel,
    register,
    action,
    errors,
    options,
    control,
    watch,
    onChange,
    paymentDate,
  } = props;

  return (
    <Modal size="xl" centered show={modal?.isOpen} onHide={() => cancel()}>
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <div className="google-maps-container"></div>
        <EditPaymentForm
          register={register}
          cancel={() => cancel()}
          action={action}
          errors={errors}
          options={options}
          watch={watch}
          modal={modal}
          paymentDate={paymentDate}
          control={control}
          onChange={onChange}
          bsDisabled={true}
        />
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const EditCashbackModal = (props) => {
  const {
    modal,
    cancel,
    register,
    action,
    errors,
    options,
    control,
    watch,
    onChange,
    fileUploaded,
    setFileUploaded,
    handleDrop,
    cashBackImage,
    removeFile,
    errorsDropzone,
  } = props;

  return (
    <Modal size="xl" centered show={modal?.isOpen} onHide={() => cancel()}>
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <div className="google-maps-container"></div>
        <EditCashbackForm
          register={register}
          cancel={() => cancel()}
          action={action}
          errors={errors}
          options={options}
          watch={watch}
          modal={modal}
          control={control}
          onChange={onChange}
          fileUploaded={fileUploaded?.image0}
          setFileUploaded={setFileUploaded}
          bsDisabled={true}
          handleDrop={handleDrop}
          cashBackImage={cashBackImage}
          removeFile={removeFile}
          errorsDropzone={errorsDropzone}
        />
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const CreateTowServiceModal = (props) => {
  const {
    show,
    handleClose,
    register,
    payTowService,
    errors,
    options,
    watch,
    onChange,
    fileUploaded,
    setFileUploaded,
    selectedProvider,
    bsDisabled,
    handleDrop,
    cashBackImage,
    removeFile,
    errorsDropzone,
    _case,
    OTP,
    showOtpByScale,
    setValue,
    showErrorAPI,
  } = props;

  return (
    <Modal size="xl" centered show={show} onHide={() => handleClose(false)}>
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <div className="google-maps-container"></div>
        <CreateTowForm
          register={register}
          cancel={() => handleClose(false)}
          action={payTowService}
          _case={_case}
          errors={errors}
          options={options}
          watch={watch}
          onChange={onChange}
          fileUploaded={fileUploaded}
          setFileUploaded={setFileUploaded}
          selectedProvider={selectedProvider}
          bsDisabled={bsDisabled}
          handleDrop={handleDrop}
          cashBackImage={cashBackImage}
          removeFile={removeFile}
          errorsDropzone={errorsDropzone}
          showOtpByScale={showOtpByScale}
          OTP={OTP}
          setValue={setValue}
          showErrorAPI={showErrorAPI}
        />
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const UploadImageModal = (props) => {
  const { handleClose, imageModal } = props;
  const solvedByAV = imageModal?.incidence?.solvedByAV;
  const [fileUploaded, setFileUploaded] = useState([]);
  const [showImages, setShowImages] = useState([true, true]);
  const [canPost, setCanPost] = useState(true);

  const images = [
    {
      name: "evidence",
      label: "AV en origen",
      message: "(PNG, JPG, JEPG, máx. 3MB)",
      uploaded: imageModal?.uploaded?.avImage,
    },
    ...(solvedByAV
      ? [
        {
          name: "evidence",
          label: "Resuelto por AV",
          message: "(PNG, JPG, JEPG, máx. 3MB)",
          uploaded: imageModal?.uploaded?.avImageSolved,
        },
      ]
      : []),
  ];

  const appendFile = (file, fieldName) => {
    const formData = new FormData();
    formData.append(fieldName, file);
    return formData;
  };

  const uploadImages = async () => {
    const uploads = [];

    if (fileUploaded[0]?.name) {
      uploads.push(
        servicesService.uploadAVImage(
          appendFile(fileUploaded[0], images[0].name),
          imageModal?.selected
        )
      );
    }

    if (solvedByAV && fileUploaded[1]?.name) {
      uploads.push(
        servicesService.uploadSolvedAvImage(
          appendFile(fileUploaded[1], "evidence"),
          imageModal?.selected
        )
      );
    }

    if (!uploads.length || !canPost) {
      return;
    }

    setCanPost(false);

    try {
      const responses = await Promise.all(uploads);
      const failedResponse = responses.find(
        (response) => ![200, 201].includes(response.status)
      );

      if (failedResponse) {
        notify(`${failedResponse.message}`, "error");
        return;
      }

      notify(`Imagen cargada con exito`, "success");
      handleClose();
      setFileUploaded([]);
      window.location.reload();
    } finally {
      setCanPost(true);
    }
  };

  const close = () => {
    setFileUploaded([]);
    handleClose();
    setShowImages(solvedByAV ? [true, true] : [true]);
  };

  return (
    <>
      <LoadSpinner show={!canPost} />
      <Modal size="xl" centered show={imageModal?.isOpen} onHide={() => close()}>
        <Modal.Header closeButton className="modal-header"></Modal.Header>
        <Modal.Body className="modal-body">
          <h1 style={{ marginBottom: "24px" }}>Cargar imágenes de servicio AV</h1>
          {images.map((img, index) => {
            return (
              <NewDropzone
                key={img?.label}
                fileUploaded={fileUploaded}
                setFileUploaded={setFileUploaded}
                img={img}
                index={index}
                setShowImages={setShowImages}
                showImages={showImages}
              />
            );
          })}
        </Modal.Body>
        <div className="buttons-center-container">
          <AltButton label={"Cancelar"} action={() => close()} />
          {fileUploaded.some((file) => file?.name) && (
            <ActionButton
              label={"Enviar Imagen"}
              action={() => uploadImages()}
            />
          )}
        </div>
        <Modal.Footer className="modal-footer"></Modal.Footer>
      </Modal>
    </>
  );
};

export const ServiceImageModal = (props) => {
  const { handleClose, imageModal } = props;

  const [fileUploaded, setFileUploaded] = useState([]);
  const [showImages, setShowImages] = useState([true, true, true]);
  const [canPost, setCanPost] = useState(true);

  const appendFile = (file) => {
    const formData = new FormData();
    for (let i = 0; i < file.length; i++) {
      if (file[i]?.name) {
        formData.append(images[i]?.name, file[i]);
      }
    }
    return formData;
  };

  const uploadImages = async () => {
    let fileToPost = appendFile(fileUploaded);

    if (canPost) {
      setCanPost(false);
      await servicesService
        .uploadTowImage(fileToPost, imageModal?.selected)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Imagenes cargadas con exito`, "success");
            handleClose();
            setFileUploaded([]);
            setCanPost(true);
            window.location.reload();
          } else {
            notify(`${response.message}`, "error");
            setCanPost(true);
          }
        });
    }
  };

  const close = () => {
    setFileUploaded([]);
    handleClose();
    setShowImages([true, true, true]);
  };

  const images = [
    {
      name: "towAtOrigin",
      label: "Gruero en origen",
      message: "(PNG, JPG, JEPG, máx. 3MB)",
      uploaded: imageModal?.uploaded?.towAtOrigin,
    },
    {
      name: "vehicleOnTow",
      label: "Vehículo en grúa",
      message: "(PNG, JPG, JEPG, máx. 3MB)",
      uploaded: imageModal?.uploaded?.vehicleOnTow,
    },
    {
      name: "vehicleOnRoad",
      label: "Vehículo en destino",
      message: "(PNG, JPG, JEPG, máx. 3MB)",
      uploaded: imageModal?.uploaded?.vehicleOnRoad,
    },
  ];

  return (
    <>
      <LoadSpinner show={!canPost} />
      <Modal
        size="xl"
        centered
        show={imageModal?.isOpen}
        onHide={() => close()}
      >
        <Modal.Header closeButton className="modal-header"></Modal.Header>
        <Modal.Body className="modal-body">
          <h1 style={{ marginBottom: "24px" }}>
            Cargar imágenes de servicio de grúa
          </h1>
          {images.map((img, index) => {
            return (
              <NewDropzone
                key={img?.name}
                fileUploaded={fileUploaded}
                setFileUploaded={setFileUploaded}
                img={img}
                index={index}
                setShowImages={setShowImages}
                showImages={showImages}
              />
            );
          })}
        </Modal.Body>
        <div className="buttons-center-container">
          <AltButton label={"Cancelar"} action={() => close()} />
          {fileUploaded.length > 0 && (
            <ActionButton
              label={"Enviar Imagen"}
              action={() => uploadImages()}
            />
          )}
        </div>
        <Modal.Footer className="modal-footer"></Modal.Footer>
      </Modal>
    </>
  );
};

const locksmithRefundCustomerName = (_case) => {
  const customer = {
    [caseType.AFFILIATED]: _case?.membership?.customer,
    [caseType.PARTICULAR]: _case?.particularCustomer,
  }[_case?.caseType] || _case?.vehicleData;
  return [customer?.firstName, customer?.lastName]
    .filter(Boolean)
    .map((n) => capitalize(n))
    .join(" ");
};

const formatLocksmithPhone = (phoneNumber) =>
  phoneNumber ? `0${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}` : "";

const formatBs = (value) =>
  Number(value).toLocaleString("es-VE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const LocksmithRefundField = ({ label, value }) => (
  <div className="locksmith-refund-field">
    <span>{label}</span>
    <b>{exists(value)}</b>
  </div>
);

export const LocksmithReimbursementModal = (props) => {
  const { handleClose, modal, refresh, dollarRate } = props;
  const _case = modal?.selected;
  const service = getLocksmithService(_case);
  const invoice = service?.locksmithInvoice;
  const isPagoMovil = invoice?.payMethod === locksmithPayMethods.PAGO_MOVIL;
  const bank = banksOptions.find((b) => b?._id === invoice?.bank);
  const price = Number(service?.price) || 0;

  const [canPost, setCanPost] = useState(true);
  const emptyRefundForm = {
    refundDate: "",
    reference: "",
    receiptImg: null,
  };
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schemas.locksmithRefundSchema),
    defaultValues: emptyRefundForm,
  });

  useEffect(() => {
    register("receiptImg");
  }, [register]);

  useEffect(() => {
    if (!modal?.isOpen) return;
    reset(emptyRefundForm);
  }, [modal?.isOpen, _case?._id, reset]);

  const close = () => {
    reset(emptyRefundForm);
    handleClose();
  };

  const handleReferenceChange = (e) => {
    e.target.value = e.target.value.replace(/\D/g, "");
    setValue("reference", e.target.value, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  const onSubmit = handleSubmit(async (form) => {
    if (!canPost || !_case?._id) {
      return;
    }

    const data = new FormData();
    data.append("refundDate", moment(form?.refundDate).format("YYYY-MM-DD"));
    data.append("reference", form?.reference);
    data.append("receiptImg", form?.receiptImg);
    data.append("service", service?._id);
    data.append("caseId", _case?._id);

    setCanPost(false);
    const response = await refundService.createRefund(data);
    if (![200, 201].includes(response?.status)) {
      notify(`${response?.message || "No pudimos cargar el reembolso"}`, "error");
      setCanPost(true);
      return;
    }

    // /refund/create tambien finaliza el caso de cerrajeria
    notify(`Reembolso cargado con éxito`, "success");
    setCanPost(true);
    close();
    refresh && refresh();
  });

  const receipt = watch("receiptImg");

  return (
    <Modal size="xl" centered show={modal?.isOpen} onHide={() => close()}>
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body locksmith-refund-modal">
        <h1>Cargar Reembolso</h1>
        <h6>(*) Campos obligatorios</h6>
        <p className="locksmith-refund-subtitle">
          {[_case?.caseId, locksmithRefundCustomerName(_case), "Cerrajería"]
            .filter(Boolean)
            .join(" · ")}
        </p>

        <div className="locksmith-refund-payment">
          <div className="locksmith-refund-payment-header">
            <b>Datos de pago del cliente</b>
            {invoice?.file && (
              <a href={invoice?.file} target="_blank" rel="noreferrer">
                Ver factura del cliente
              </a>
            )}
          </div>
          <div className="locksmith-refund-payment-fields">
            <LocksmithRefundField label="Método" value={invoice?.payMethod} />
            <LocksmithRefundField
              label="Banco"
              value={bank ? `${bank?._id} - ${bank?.name}` : invoice?.bank}
            />
            {isPagoMovil ? (
              <>
                <LocksmithRefundField
                  label="Teléfono"
                  value={formatLocksmithPhone(invoice?.phoneNumber)}
                />
                <LocksmithRefundField
                  label="Cédula"
                  value={
                    invoice?.identification &&
                    `${invoice?.identificationType}-${invoice?.identification}`
                  }
                />
              </>
            ) : (
              <>
                <LocksmithRefundField label="Cuenta" value={invoice?.account} />
                <LocksmithRefundField label="Titular" value={invoice?.fullName} />
              </>
            )}
            <LocksmithRefundField label="Monto USD" value={price || ""} />
            <LocksmithRefundField
              label="Monto Bs"
              value={price && dollarRate ? formatBs(price * dollarRate) : ""}
            />
          </div>
        </div>

        <div className="locksmith-refund-form">
          <div className="row">
            <div className="col-md-3 locksmith-refund-input">
              <label htmlFor="refundDate">Fecha del reembolso *</label>
              <input
                id="refundDate"
                type="date"
                max={moment().format("YYYY-MM-DD")}
                {...register("refundDate")}
              />
              <p className="error-message">{errors?.refundDate?.message}</p>
            </div>
            <div className="col-md-5 locksmith-refund-input">
              <label htmlFor="reference">Número de referencia *</label>
              <input
                id="reference"
                type="text"
                inputMode="numeric"
                placeholder="Ej. 000123456789"
                {...register("reference")}
                onChange={handleReferenceChange}
              />
              <p className="error-message">{errors?.reference?.message}</p>
            </div>
            <div className="col-md-10 locksmith-refund-input">
              <label htmlFor="receiptImg">Comprobante del reembolso *</label>
              <label className="locksmith-refund-file" htmlFor="receiptImg">
                <span>Seleccionar archivo</span>
                <span>{receipt?.name || "Ningún archivo seleccionado"}</span>
              </label>
              <input
                key={modal?.isOpen ? _case?._id || "open" : "closed"}
                id="receiptImg"
                type="file"
                accept="image/jpeg,image/png"
                hidden
                onChange={(e) =>
                  setValue("receiptImg", e?.target?.files?.[0], {
                    shouldValidate: true,
                  })
                }
              />
              <small>Formatos permitidos: JPG, PNG</small>
              <p className="error-message">{errors?.receiptImg?.message}</p>
            </div>
          </div>
        </div>

        <div className="buttons-center-container">
          <AltButton label={"Cancelar"} action={() => close()} />
          <ActionButton
            label={"Guardar"}
            action={() => onSubmit()}
            disabled={!canPost}
          />
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

const locksmithFinishCopy = {
  [locksmithFinishMode.CANCEL]: {
    title: "Caso sin factura cargada",
    body: "Este caso no tiene la factura del cliente cargada.",
    emphasis: "El caso se cancelará y no podrá procesarse el reembolso.",
    question: "¿Estás seguro de que deseas continuar?",
    confirm: "Sí, cancelar caso",
    success: "Caso cancelado con éxito",
  },
  [locksmithFinishMode.BLOCK]: {
    title: "Falta el reembolso",
    body: "Este caso tiene la factura cargada, pero no tiene reembolso.",
    emphasis: "No se puede finalizar y el servicio no se descontará.",
    question: "Carga el reembolso antes de finalizar el caso.",
    confirm: null,
    success: null,
  },
  [locksmithFinishMode.FINISH]: {
    title: "Finalizar caso",
    body: "Este caso tiene la factura y el reembolso cargados.",
    emphasis: "El caso se finalizará y el servicio se descontará.",
    question: "¿Estás seguro de que deseas continuar?",
    confirm: "Sí, finalizar caso",
    success: "Caso finalizado con éxito",
  },
};

const cancelLocksmithWithoutDeduct = async (_case) => {
  const reasonsResponse = await membershipService.getCancelReason(
    resolveCancelReasonType(_case)
  );
  if (reasonsResponse?.status !== 200) {
    return {
      status: reasonsResponse?.status || 400,
      message:
        reasonsResponse?.message ||
        "No pudimos cargar los motivos de cancelación.",
    };
  }
  const reasons = reasonsResponse?.data?.newCancellationReasons || [];
  const reason =
    reasons.find((item) => /sin factura/i.test(item?.name || "")) ||
    reasons.find((item) => /^otro$/i.test(item?.name || "")) ||
    reasons[0];

  if (!reason?._id) {
    return {
      status: 400,
      message:
        "No hay un motivo de cancelación para cerrar el caso sin descontar el servicio.",
    };
  }

  return caseService.cancelCase(
    {
      cancelationReason: reason._id,
      cancelationReasonDescription:
        "Caso de cerrajería sin factura del cliente. No se descuenta el servicio.",
    },
    _case._id
  );
};

export const LocksmithFinishModal = (props) => {
  const { modal, handleClose, refresh } = props;
  const [isLoading, setIsLoading] = useState(false);
  const copy =
    locksmithFinishCopy[modal?.mode] ||
    locksmithFinishCopy[locksmithFinishMode.CANCEL];
  const canConfirm = !!copy.confirm && modal?.mode !== locksmithFinishMode.BLOCK;

  const close = () => {
    if (isLoading) return;
    handleClose();
  };

  const confirm = async () => {
    const _case = modal?.selected;
    if (isLoading || !canConfirm || !_case?._id) return;

    // Se vuelve a evaluar la factura y el reembolso antes de tocar el caso.
    const mode = getLocksmithFinishMode(_case);
    if (mode === locksmithFinishMode.BLOCK) {
      notify(
        "Este caso tiene factura y no tiene reembolso. No se puede finalizar ni descontar el servicio.",
        "error"
      );
      return;
    }

    setIsLoading(true);
    try {
      const response =
        mode === locksmithFinishMode.CANCEL
          ? await cancelLocksmithWithoutDeduct(_case)
          : await caseService.finalizeLocksmith(_case._id);

      if ([200, 201].includes(response?.status)) {
        notify(
          mode === locksmithFinishMode.CANCEL
            ? locksmithFinishCopy[locksmithFinishMode.CANCEL].success
            : locksmithFinishCopy[locksmithFinishMode.FINISH].success,
          "success"
        );
        handleClose();
        refresh();
        return;
      }
      notify(
        `${response?.message || "No pudimos actualizar el caso de cerrajería"}`,
        "error"
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      centered
      show={!!modal?.isOpen}
      onHide={close}
      dialogClassName="locksmith-finish-dialog"
    >
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <div className="locksmith-finish-modal">
          <div className="locksmith-finish-icon" aria-hidden="true">
            !
          </div>
          <h5>{copy.title}</h5>
          <p>{copy.body}</p>
          <p className="locksmith-finish-emphasis">{copy.emphasis}</p>
          {copy.question && (
            <p className="locksmith-finish-question">{copy.question}</p>
          )}
          <div className="buttons-center-container">
            <AltButton label={canConfirm ? "No, volver" : "Volver"} action={close} />
            {canConfirm && (
              <ActionButton
                label={copy.confirm}
                action={confirm}
                disabled={isLoading}
              />
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const CancelServiceModal = (props) => {
  const { modal, refresh, handleClose, cancelService } = props;

  const close = () => {
    handleClose(false);
    refresh();
  };

  return (
    <>
      <Modal size="xl" centered show={modal?.show} onHide={() => close()}>
        <Modal.Header closeButton className="modal-header"></Modal.Header>
        <Modal.Body className="modal-body">
          <h5 style={{ marginBottom: "24px" }}>Cancelar Servicio</h5>

          <CancelServicesTable
            header={cancelServiceHeader}
            data={modal?.services}
            cancelService={cancelService}
          />
        </Modal.Body>
        <Modal.Footer className="modal-footer"></Modal.Footer>
      </Modal>
    </>
  );
};

export const ChangeCaseStageModal = (props) => {
  const { showChangeStatusModal, handleClose, updateCaseStage } = props;

  return (
    <Modal
      size="lg"
      centered
      show={showChangeStatusModal?.isOpen}
      onHide={() => handleClose()}
    >
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h3 style={{ marginBottom: "24px" }}>
          Mover caso {showChangeStatusModal?.selected?.caseId} a{" "}
          {showChangeStatusModal?.nextStatus}{" "}
        </h3>
        <h6 className="change-case-stage-modal" style={{ margin: "24px" }}>
          ¿Está seguro que desea mover el caso:{" "}
          {showChangeStatusModal?.selected?.caseId} de <br />
          <b>{showChangeStatusModal?.selected?.lastStage?.name}</b> a{" "}
          <b>{showChangeStatusModal?.nextStatus}</b>?
        </h6>
      </Modal.Body>
      <div className="buttons-center-container">
        <AltButton label={"No"} action={() => handleClose()} />
        <ActionButton
          label={"Si, cambiar de estatus"}
          action={() => updateCaseStage()}
        />
      </div>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const CreateFleetMaintenanceModal = (props) => {
  const {
    show,
    handleClose,
    register,
    errors,
    options,
    watch,
    title,
    control,
    setValue,
    action,
  } = props;

  setValue("type", "Grúa");
  setValue("creationDate", new Date());
  setValue("unitStatus", "Accidentada");

  return (
    <Modal size="xl" centered show={show} onHide={() => handleClose(false)}>
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <div className="google-maps-container"></div>
        <CreateFleetMaintenanceForm
          title={title}
          register={register}
          cancel={() => handleClose(false)}
          errors={errors}
          options={options}
          watch={watch}
          control={control}
          action={action}
          setValue={setValue}
        />
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const EditFleetMaintenanceModal = (props) => {
  const {
    show,
    handleClose,
    register,
    errors,
    options,
    watch,
    title,
    control,
    setValue,
    action,
  } = props;

  return (
    <Modal
      size="xl"
      centered
      show={show.isOpen}
      onHide={() => handleClose(false)}
    >
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <div className="google-maps-container"></div>
        <CreateFleetMaintenanceForm
          title={title}
          register={register}
          cancel={() => handleClose(false)}
          errors={errors}
          options={options}
          watch={watch}
          control={control}
          action={action}
          setValue={setValue}
        />
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const CreateFleetIncidenceModal = (props) => {
  const {
    show,
    handleClose,
    register,
    errors,
    options,
    watch,
    title,
    control,
    setValue,
    action,
    onChange,
  } = props;

  return (
    <Modal size="xl" centered show={show} onHide={() => handleClose(false)}>
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <div className="google-maps-container"></div>
        <CreateFleetIncidenceForm
          title={title}
          register={register}
          cancel={() => handleClose(false)}
          errors={errors}
          options={options}
          watch={watch}
          control={control}
          action={action}
          setValue={setValue}
          onChange={onChange}
        />
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const EditFleetIncidenceModal = (props) => {
  const {
    show,
    handleClose,
    register,
    errors,
    options,
    watch,
    title,
    control,
    setValue,
    action,
    onChange,
  } = props;

  return (
    <Modal
      size="xl"
      centered
      show={show.isOpen}
      onHide={() => handleClose(false)}
    >
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <div className="google-maps-container"></div>
        <CreateFleetIncidenceForm
          title={title}
          register={register}
          cancel={() => handleClose(false)}
          errors={errors}
          options={options}
          watch={watch}
          control={control}
          action={action}
          setValue={setValue}
          onChange={onChange}
        />
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const UpdateAVResolvedModal = (props) => {
  const { handleClose, show, action } = props;

  const close = () => {
    handleClose();
  };

  return (
    <Modal size="lg" centered show={show?.show} onHide={() => close()}>
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h4 style={{ marginBottom: "24px" }}>
          {`Estas seguro de que deseas ${show.status === AVFaultServiceResolvedStatus.APPROVED
            ? "Aprobar"
            : "Rechazar"
            }
          este servicio?`}
        </h4>
      </Modal.Body>
      <div className="buttons-center-container">
        <AltButton label={"Cancelar"} action={() => close()} />
        <ActionButton
          label={
            show.status === AVFaultServiceResolvedStatus.APPROVED
              ? "Aprobar"
              : "Rechazar"
          }
          action={() => action(show.id, show.status)}
        />
      </div>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const DailyReportModal = (props) => {
  const {
    modal,
    control,
    handleClose,
    action,
    errors,
    register,
    clipboardData,
  } = props;

  return (
    <Modal size="lg" centered show={modal} onHide={() => handleClose()}>
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h4 style={{ marginBottom: "24px" }}>Reporte del día</h4>
        {!Object.keys(clipboardData).length > 0 && (
          <>
            <div
              className="row"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Input
                bootstrap={"col-6"}
                label={"Fecha Inicio"}
                type={"date-time"}
                name={"hourFrom"}
                minDate={moment().subtract(1, "days").toDate()}
                maxDate={moment().toDate()}
                register={register}
                control={control}
                errors={errors?.hourFrom?.message}
              />
              <Input
                bootstrap={"col-6"}
                label={"Fecha Fin"}
                control={control}
                type={"date-time"}
                name={"hourTo"}
                minDate={moment().toDate()}
                maxDate={moment().add(1, "days").toDate()}
                register={register}
                errors={errors?.hourTo?.message}
              />
            </div>
            <div className="row">
              <Input
                bootstrap={"col-12"}
                label={"Errores Cometidos"}
                type={"number"}
                name={"errorCommited"}
                register={register}
                errors={errors?.errorCommited?.message}
              />
            </div>{" "}
            <div className="row">
              <ActionButton
                label={"Enviar"}
                action={action}
                disabled={Object.keys(clipboardData).length > 0}
              />
            </div>
          </>
        )}

        {/* if clipboardData is nor an emptyObject */}
        {Object.keys(clipboardData).length > 0 && (
          <DailyReportMessageComponent data={clipboardData} />
        )}
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const DailyReportMessageComponent = (props) => {
  const { data } = props;
  let externalTows = 0;
  if (data?.doneCases?.towExternal) {
    for (let service in data?.doneCases?.towExternal) {
      externalTows += data?.doneCases?.towExternal[service]?.num;
    }
    data.doneCases.externalTowsInt = externalTows;
  }
  return (
    <div className="modal-message-container">
      <p>
        <b>Reporte del día:</b>
        <br />
        <br />
        <b>- Turno: </b>
        {`${moment(data?.startDate).format("DD/MM/YYYY hh:mm a")} - ${moment(
          data?.endDate
        ).format("DD/MM/YYYY hh:mm a")}`}
        <br />
        <b>- Nombre: </b>
        {data?.user}
        <br />
        <b>- Número de quejas: </b>
        {data?.reportedErrors}
        <br />
        <b>- Número de particulares: </b>
        {data?.doneCases?.particular}
        <br />
        <b>- Número de agendados: </b>
        {data?.activeCases?.scheduled}
        <br />
        <b>- Servicios activos: </b>
        {data?.activeCases?.active}
        <br />
        <b>- Total servicios prestados: </b>
        {data?.doneCases?.done}
        <br />
        <b>- Grúas externas aprobadas: </b>
        {data?.doneCases?.doneTowExternal}
        <br />
        {data?.doneCases?.towExternalCcs &&
          Object.entries(data?.doneCases?.towExternalCcs).map(
            ([key, value]) => (
              <div key={key}>
                <span>{` - Caracas: ${value} ${key}`}</span>
                <br />
              </div>
            )
          )}

        {data?.doneCases?.towExternal &&
          Object.entries(data?.doneCases?.towExternal).map(([key, value]) => (
            <div key={key}>
              <span>{` - ${value.name}: ${value.num}`}</span>
              <br />
            </div>
          ))}
        <b>- Grúas internas aprobadas: </b>
        {data?.doneCases?.doneTowInternal}
        <br />
      </p>
      <CopyButton text={smsText.sendDailyReport(data)} />
    </div>
  );
};

export const CreateComplaintModal = (props) => {
  const {
    show,
    handleClose,
    register,
    errors,
    options,
    watch,
    title,
    control,
    setValue,
    action,
    onChange,
    getServicesByCode,
  } = props;

  return (
    <Modal size="xl" centered show={show} onHide={() => handleClose()}>
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <ComplaintsForm
          title={title}
          register={register}
          cancel={() => handleClose()}
          errors={errors}
          options={options}
          watch={watch}
          control={control}
          action={action}
          setValue={setValue}
          onChange={onChange}
          getServicesByCode={getServicesByCode}
        />
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const EditComplaintModal = (props) => {
  const {
    show,
    handleClose,
    register,
    errors,
    options,
    watch,
    title,
    control,
    setValue,
    action,
    onChange,
    getServicesByCode,
  } = props;

  return (
    <Modal size="xl" centered show={show} onHide={() => handleClose()}>
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <ComplaintsForm
          title={title}
          register={register}
          cancel={() => handleClose()}
          errors={errors}
          options={options}
          watch={watch}
          control={control}
          action={action}
          setValue={setValue}
          onChange={onChange}
          getServicesByCode={getServicesByCode}
        />
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};

export const UploadBatteryInventoryModal = (props) => {
  const {
    handleCloseModal,
    show,
    fileUploaded,
    setFileUploaded,
    getInputProps,
    getRootProps,
    message,
    upload,
  } = props;
  const close = () => {
    handleCloseModal();
  };

  return (
    <Modal size="lg" centered show={show} onHide={() => close()}>
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h1 style={{ marginBottom: "32px" }}>Cargar inventario de batería</h1>
        <p>{"Campo Obligatorio (*)"}</p>
        <div
          className="dropzone-container"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <h6>
            <b>Adjuntar archivo de inventario de batería</b>
          </h6>
          <h6>
            <b>{"(.xlsx)"}</b>
          </h6>
          {fileUploaded ? (
            <FileComponent
              file={fileUploaded}
              remove={() => setFileUploaded("")}
            />
          ) : (
            <Dropzone
              getRootProps={getRootProps}
              getInputProps={getInputProps}
              message={message}
            />
          )}
        </div>
      </Modal.Body>
      <div className="buttons-center-container">
        <AltButton label={"Cancelar"} action={() => close()} />
        {fileUploaded && (
          <ActionButton label={"Cargar Archivo"} action={() => upload()} />
        )}
      </div>
    </Modal>
  );
};

export const ConciliacionMasivaModal = (props) => {
  const {
    handleCloseModal,
    show,
    fileUploaded,
    setFileUploaded,
    getInputProps,
    getRootProps,
    message,
    upload,
    isLoading,
  } = props;

  const close = () => {
    if (isLoading) return;
    handleCloseModal();
  };

  return (
    <Modal
      size="lg"
      centered
      show={show}
      onHide={() => close()}
      backdrop={isLoading ? "static" : true}
      keyboard={!isLoading}
    >
      <Modal.Header closeButton={!isLoading} className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h1 style={{ marginBottom: "32px" }}>Conciliación masiva</h1>
        <div
          className="dropzone-container"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {fileUploaded ? (
            <FileComponent
              file={fileUploaded}
              remove={() => !isLoading && setFileUploaded("")}
            />
          ) : (
            <Dropzone
              getRootProps={getRootProps}
              getInputProps={getInputProps}
              message={message}
            />
          )}
        </div>
      </Modal.Body>
      <div className="buttons-center-container">
        {isLoading ? (
          <ActionButton label={"Conciliar"} disabled />
        ) : (
          <>
            <AltButton label={"Cancelar"} action={() => close()} />
            {fileUploaded && (
              <ActionButton label={"Conciliar"} action={() => upload()} />
            )}
          </>
        )}
      </div>
    </Modal>
  );
};

export const SendFileModal = (props) => {
  const {
    imageModal,
    handleImageModal,
    setFileUploaded,
    fileUploaded,
    getRootProps,
    getInputProps,
    uploadAVImage,
  } = props;

  return (
    <Modal size="lg" centered show={imageModal?.isOpen} onHide={handleImageModal}>
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h1 style={{ marginBottom: '32px' }}>{imageModal?.label || 'Cargar Archivo'}</h1>
        <p>{"Campo Obligatorio (*)"}</p>
        <div
          className="dropzone-container"
          style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
        >
          <h6>
            <b>Adjuntar {imageModal?.label || 'archivo'}</b>
          </h6>
          <h6>
            <b>{imageModal?.message || ''}</b>
          </h6>
          {fileUploaded ? (
            <FileComponent file={fileUploaded} remove={() => setFileUploaded('')} />
          ) : (
            <Dropzone getRootProps={getRootProps} getInputProps={getInputProps} message={imageModal?.message} />
          )}
        </div>
      </Modal.Body>
      <div className="buttons-center-container">
        <AltButton label="Cancelar" action={handleImageModal} />
        {fileUploaded && (
          <ActionButton label="Cargar Archivo" action={uploadAVImage} />
        )}
      </div>
    </Modal>
  );
};

export const BatterySaleModal = (props) => {
  const {
    showSMSModal,
    handleClose,
    action,
    register,
    errors,
    options,
    onChange,
  } = props;
  return (
    <Modal
      size="xl"
      centered
      show={showSMSModal?.isOpen}
      onHide={() => handleClose(false)}
    >
      <Modal.Header className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h4>Venta de Batería</h4>
        <BatterySaleForm
          register={register}
          errors={errors}
          options={options}
          action={action}
          onChange={onChange}
        />

        <div className="buttons-center-container">
          <AltButton label={"Cerrar"} action={() => handleClose(false)} />{" "}
          {action && <ActionButton label={"Guardar"} action={() => action()} />}
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
};
